
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("lWz4S", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");





var $jKLZ2 = parcelRequire("jKLZ2");

// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $a94ae00f2461c7f0$export$682b3626c052cb96 = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;



var $hDLmU = parcelRequire("hDLmU");


var $iDdTC = parcelRequire("iDdTC");


var $lCTbz = parcelRequire("lCTbz");

const $9de216ec204701cf$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $9de216ec204701cf$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $9de216ec204701cf$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $9de216ec204701cf$var$timings
    }
};
const $9de216ec204701cf$export$a23245993532c751 = (contentType)=>(0, $iDdTC.metrics).pageSegmentLoad($9de216ec204701cf$var$loadingMetricsConfig[contentType]);





const $f502062d9e0bf561$export$4de078c3b9971f9b = ()=>(0, $iDdTC.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });


const $95d0f62d85575770$export$2881499e37b75b9a = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $cozmU.useState)(contentType);
    const isInitialized = (0, $cozmU.useRef)(true);
    const iframeLoadMetrics = (0, $cozmU.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $cozmU.useRef)();
    (0, $cozmU.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $f502062d9e0bf561$export$4de078c3b9971f9b)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: (0, $a94ae00f2461c7f0$export$682b3626c052cb96)(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: (0, $a94ae00f2461c7f0$export$682b3626c052cb96)(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: (0, $a94ae00f2461c7f0$export$682b3626c052cb96)(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: (0, $a94ae00f2461c7f0$export$682b3626c052cb96)(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', (0, $a94ae00f2461c7f0$export$682b3626c052cb96)(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $cozmU.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $9de216ec204701cf$export$a23245993532c751)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $cozmU.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $cozmU.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jKLZ2.PerformanceMetricsContext).Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        }
    }, children);
};



var $bIcvA = parcelRequire("bIcvA");



const $495e0a92c5164d61$export$c6f19d9afc6c86c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, contentType: contentType, sourceComponent: sourceComponent } = t0;
    const { isInitialized: isInitialized, setContentType: setContentType } = (0, $bIcvA.usePerformanceMetrics)();
    let t1;
    let t2;
    if ($[0] !== contentType || $[1] !== isInitialized || $[2] !== setContentType) {
        t1 = ()=>{
            isInitialized && contentType && setContentType(contentType);
        };
        t2 = [
            isInitialized,
            contentType,
            setContentType
        ];
        $[0] = contentType;
        $[1] = isInitialized;
        $[2] = setContentType;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[5] !== children || $[6] !== contentType || $[7] !== isInitialized || $[8] !== sourceComponent) {
        t3 = !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95d0f62d85575770$export$2881499e37b75b9a), {
            contentType: contentType,
            sourceComponent: sourceComponent
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[5] = children;
        $[6] = contentType;
        $[7] = isInitialized;
        $[8] = sourceComponent;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = (0, $bIcvA.usePerformanceMetrics)();
    (0, $cozmU.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95d0f62d85575770$export$2881499e37b75b9a), {
        contentType: contentType,
        sourceComponent: sourceComponent
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["PerformanceMetricsProvider"] = $495e0a92c5164d61$export$c6f19d9afc6c86c8;

});

parcelRegister("3cycN", function(module, exports) {

























const $11491382b2b129de$var$importTranslations = async (locale)=>{
    switch(locale){
        case 'cs-CZ':
            return (parcelRequire("kInXW"));
        case 'da-DK':
            return (parcelRequire("fnHGm"));
        case 'de-DE':
            return (parcelRequire("k7FcA"));
        case 'en-US':
            return (parcelRequire("k7i9n"));
        case 'en-GB':
            return (parcelRequire("iC8Tg"));
        case 'en-ZZ':
            return (parcelRequire("3L3Xj"));
        case 'es-ES':
            return (parcelRequire("4knDK"));
        case 'fi-FI':
            return (parcelRequire("6qq5F"));
        case 'fr-FR':
            return (parcelRequire("KJMmk"));
        case 'hu-HU':
            return (parcelRequire("j1E7J"));
        case 'it-IT':
            return (parcelRequire("bURwc"));
        case 'ja-JP':
            return (parcelRequire("8HHkc"));
        case 'ko-KR':
            return (parcelRequire("gdoAU"));
        case 'no-NO':
            return (parcelRequire("jEGce"));
        case 'nl-NL':
            return (parcelRequire("iayBy"));
        case 'pl-PL':
            return (parcelRequire("fN7x7"));
        case 'pt-BR':
            return (parcelRequire("i9zlH"));
        case 'ru-RU':
            return (parcelRequire("cKesM"));
        case 'sv-SE':
            return (parcelRequire("4ua6B"));
        case 'tr-TR':
            return (parcelRequire("gfi0e"));
        case 'th-TH':
            return (parcelRequire("3SCy1"));
        case 'uk-UA':
            return (parcelRequire("bIZVf"));
        case 'vi-VN':
            return (parcelRequire("5LbXa"));
        case 'zh-TW':
            return (parcelRequire("htJYC"));
        case 'zh-CN':
            return (parcelRequire("bQZAa"));
        default:
            return Promise.resolve({
                default: {}
            });
    }
};
const $11491382b2b129de$var$fetchTranslations = async (locale)=>{
    const module = await $11491382b2b129de$var$importTranslations(locale);
    return module.default;
};
var $11491382b2b129de$export$2e2bcd8739ae039 = $11491382b2b129de$var$fetchTranslations;
module.exports["default"] = $11491382b2b129de$export$2e2bcd8739ae039;

});

parcelRegister("kInXW", function(module, exports) {

let $f14a81d519c09a73$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f14a81d519c09a73$var$load("3ljNx").then(()=>parcelRequire('jliL6'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("fnHGm", function(module, exports) {

let $b32ae364d53075dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b32ae364d53075dd$var$load("9HiuR").then(()=>parcelRequire('4yM4Q'));

});

parcelRegister("k7FcA", function(module, exports) {

let $ea646bf99e21c9f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea646bf99e21c9f5$var$load("5HEaC").then(()=>parcelRequire('iaKCQ'));

});

parcelRegister("k7i9n", function(module, exports) {

let $ea528a5830577d47$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea528a5830577d47$var$load("bc5n7").then(()=>parcelRequire('gEziS'));

});

parcelRegister("iC8Tg", function(module, exports) {

let $d8d2ac08a72bc77a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8d2ac08a72bc77a$var$load("6aUsM").then(()=>parcelRequire('8RYVS'));

});

parcelRegister("3L3Xj", function(module, exports) {

let $2bc8d46438330650$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2bc8d46438330650$var$load("630kv").then(()=>parcelRequire('lt752'));

});

parcelRegister("4knDK", function(module, exports) {

let $326b5e1627110d1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $326b5e1627110d1d$var$load("geF5z").then(()=>parcelRequire('68Cm2'));

});

parcelRegister("6qq5F", function(module, exports) {

let $4ad968c904ad9fcb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ad968c904ad9fcb$var$load("gA2D6").then(()=>parcelRequire('gIWUj'));

});

parcelRegister("KJMmk", function(module, exports) {

let $08c7cebec7fac655$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $08c7cebec7fac655$var$load("kzbEu").then(()=>parcelRequire('8y8I9'));

});

parcelRegister("j1E7J", function(module, exports) {

let $dd9d3c0a35f173bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd9d3c0a35f173bc$var$load("gVuni").then(()=>parcelRequire('gi13Z'));

});

parcelRegister("bURwc", function(module, exports) {

let $8ace704fbc3e97f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ace704fbc3e97f3$var$load("8nyPJ").then(()=>parcelRequire('2Orbm'));

});

parcelRegister("8HHkc", function(module, exports) {

let $6563f24b52a96311$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6563f24b52a96311$var$load("gAHoS").then(()=>parcelRequire('493Gf'));

});

parcelRegister("gdoAU", function(module, exports) {

let $bce0f02d60a1fb6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bce0f02d60a1fb6b$var$load("hRm4B").then(()=>parcelRequire('lShyP'));

});

parcelRegister("jEGce", function(module, exports) {

let $e4f27c075979b8a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e4f27c075979b8a8$var$load("aztzd").then(()=>parcelRequire('9bV8a'));

});

parcelRegister("iayBy", function(module, exports) {

let $d3a400f43ef34e9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3a400f43ef34e9c$var$load("83Lnu").then(()=>parcelRequire('4DAuQ'));

});

parcelRegister("fN7x7", function(module, exports) {

let $b7f14686491fbad8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7f14686491fbad8$var$load("b4Pzk").then(()=>parcelRequire('gt9eB'));

});

parcelRegister("i9zlH", function(module, exports) {

let $d3747cd88d3be1f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3747cd88d3be1f9$var$load("b2ZZH").then(()=>parcelRequire('9zt0t'));

});

parcelRegister("cKesM", function(module, exports) {

let $9475000252f11f04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9475000252f11f04$var$load("9y5a8").then(()=>parcelRequire('cZ7p0'));

});

parcelRegister("4ua6B", function(module, exports) {

let $3441cd806e6b54cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3441cd806e6b54cd$var$load("gxf8P").then(()=>parcelRequire('d3Th1'));

});

parcelRegister("gfi0e", function(module, exports) {

let $bd3c0303bab840bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd3c0303bab840bc$var$load("7T32B").then(()=>parcelRequire('75xjP'));

});

parcelRegister("3SCy1", function(module, exports) {

let $2d345104e871b0b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d345104e871b0b7$var$load("7M39h").then(()=>parcelRequire('1DlG3'));

});

parcelRegister("bIZVf", function(module, exports) {

let $8893d64675ed2408$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8893d64675ed2408$var$load("PuDiT").then(()=>parcelRequire('2kbv7'));

});

parcelRegister("5LbXa", function(module, exports) {

let $431a9d3a74035fe7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $431a9d3a74035fe7$var$load("kJmNW").then(()=>parcelRequire('bVtbU'));

});

parcelRegister("htJYC", function(module, exports) {

let $cb98cf18e739a4b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb98cf18e739a4b2$var$load("cQhlD").then(()=>parcelRequire('d7i4R'));

});

parcelRegister("bQZAa", function(module, exports) {

let $8a1452062a292e85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a1452062a292e85$var$load("htClT").then(()=>parcelRequire('etZ4h'));

});

parcelRegister("6JLuV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9f1Yt = parcelRequire("9f1Yt");


var $7avaU = parcelRequire("7avaU");

var $yx6Pm = parcelRequire("yx6Pm");

var $6B1vK = parcelRequire("6B1vK");

var $iJxD8 = parcelRequire("iJxD8");

var $fjKr7 = parcelRequire("fjKr7");

var $1RQo0 = parcelRequire("1RQo0");

var $aLUFu = parcelRequire("aLUFu");


var $dAzRS = parcelRequire("dAzRS");


var $Gq5Ho = parcelRequire("Gq5Ho");

const $9324e169fd2f8d87$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-blogpost',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project',
    'cmdb-object'
];



var $gtMdU = parcelRequire("gtMdU");





var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $cXtTj = parcelRequire("cXtTj");


var $8OpiN = parcelRequire("8OpiN");


var $6CsCB = parcelRequire("6CsCB");


var $hMaHH = parcelRequire("hMaHH");


var $iFXu4 = parcelRequire("iFXu4");


var $d4GYd = parcelRequire("d4GYd");


var $dflgH = parcelRequire("dflgH");


var $bDjVc = parcelRequire("bDjVc");


var $iRFKG = parcelRequire("iRFKG");


var $f1iv3 = parcelRequire("f1iv3");


var $iDrrr = parcelRequire("iDrrr");


var $2zVsi = parcelRequire("2zVsi");





var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


const $57ad7e92d2bdb34f$export$a50c261b4b52f403 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("2w19Y"))), {
        moduleId: "d73b44f1",
        priority: "interaction",
        moduleId: 'confluence-preview-panel-entrypoint'
    }),
    getPreloadProps: ()=>({})
});



var $eYg5X = parcelRequire("eYg5X");


var $6AkEJ = parcelRequire("6AkEJ");


var $df5DJ = parcelRequire("df5DJ");


var $4slsU = parcelRequire("4slsU");








var $5mzE3 = parcelRequire("5mzE3");

const $2020c81a177e1777$var$fetchPolicy = 'network-only';

const $2020c81a177e1777$var$atlasGoalEntryPoint = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("ggAfO")), {
        moduleId: "ba76ccc1",
        moduleName: "GoalPanel",
        priority: "interaction",
        moduleId: 'atlas-goal-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $eYg5X.default)('townsquare-goal-panel-opened');
        const siteId = (0, $4slsU.getSiteId)('goal', ari);
        const queryContext = siteId ? (0, $6AkEJ.createPlatformSiteAri)(siteId) : null;
        const capabilitiesContainerId = siteId ? (0, $df5DJ.getProjectSiteAri)(siteId) : '';
        return {
            queries: {
                queryReference: {
                    parameters: $5mzE3.default,
                    variables: {
                        ari: ari,
                        queryContext: queryContext,
                        capabilitiesContainerId: capabilitiesContainerId
                    },
                    options: {
                        fetchPolicy: $2020c81a177e1777$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $2020c81a177e1777$export$2e2bcd8739ae039 = $2020c81a177e1777$var$atlasGoalEntryPoint;









const $33101bec474714ae$var$objectPreviewPanelEntryPoint = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("jyaqh")), {
        moduleId: "bb3d75a4",
        priority: "interaction",
        moduleId: 'object-preview-panel-entrypoint'
    }),
    getPreloadProps: ({})=>({})
});
var $33101bec474714ae$export$2e2bcd8739ae039 = $33101bec474714ae$var$objectPreviewPanelEntryPoint;



var $lRhY3 = parcelRequire("lRhY3");











var $fvoKJ = parcelRequire("fvoKJ");











var $9fwsK = parcelRequire("9fwsK");

const $f5f05018b4a542da$var$fetchPolicy = 'network-only';

const $f5f05018b4a542da$var$atlasProjectEntryPoint = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("fJCUp")), {
        moduleId: "db5db9ea",
        moduleName: "ProjectPanel",
        priority: "interaction",
        moduleId: 'atlas-project-entrypoint'
    }),
    getPreloadProps: ({ ari: ari })=>{
        (0, $eYg5X.default)('townsquare-project-panel-opened');
        // check for M0 or greater
        const isProjectNativeIntegrationEnabled = (0, $cXtTj.default).getExperimentValue('atlassian_projects_-_native_integration', 'releaseVersion', -1) >= 0;
        const siteId = (0, $4slsU.getSiteId)('project', ari);
        const queryContext = siteId ? (0, $6AkEJ.createPlatformSiteAri)(siteId) : null;
        const capabilitiesContainerId = siteId ? (0, $fvoKJ.getSiteAri)(siteId) : '';
        return {
            queries: {
                queryReference: {
                    parameters: $9fwsK.default,
                    variables: {
                        ari: ari,
                        isProjectNativeIntegrationEnabled: isProjectNativeIntegrationEnabled,
                        queryContext: queryContext,
                        capabilitiesContainerId: capabilitiesContainerId,
                        cloudId: siteId
                    },
                    options: {
                        fetchPolicy: $f5f05018b4a542da$var$fetchPolicy
                    }
                }
            }
        };
    }
});
var $f5f05018b4a542da$export$2e2bcd8739ae039 = $f5f05018b4a542da$var$atlasProjectEntryPoint;


/*
 * Get the default tab from the url
 * Post T25 EU task: Support other URL routing (jira/jira-align/highlights, ect)
 * TODO: https://product-fabric.atlassian.net/browse/TC-14119
 */ function $3a838e14fe15d330$export$68d1d951742105ed(url) {
    // About | Updates | {other tabs}
    if (url.includes('updates')) return 'updates';
    return 'about';
}



var $d5gEx = parcelRequire("d5gEx");








var $fOZAE = parcelRequire("fOZAE");

const $13370b928e51f660$var$fetchPolicy = 'network-only';

const $13370b928e51f660$var$teamPreviewPanelEntryPoint = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("jlGvh")), {
        moduleId: "bc41c2d8",
        priority: "interaction",
        moduleId: 'team-preview-panel-entrypoint'
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                queryReference: {
                    parameters: $fOZAE.default,
                    variables: {
                        cloudId: cloudId
                    },
                    options: {
                        fetchPolicy: $13370b928e51f660$var$fetchPolicy
                    }
                }
            }
        })
});
var $13370b928e51f660$export$2e2bcd8739ae039 = $13370b928e51f660$var$teamPreviewPanelEntryPoint;






const $7460fd5d96862093$var$_default_1 = (0, $kSwu1.defineMessages)({
    workItem: {
        id: "navigation.preview-panel-global-objects.workItem",
        defaultMessage: "Jira work item"
    },
    project: {
        id: "navigation.preview-panel-global-objects.project",
        defaultMessage: "Project"
    },
    goal: {
        id: "navigation.preview-panel-global-objects.goal",
        defaultMessage: "Goal"
    },
    team: {
        id: "navigation.preview-panel-global-objects.team",
        defaultMessage: "Team"
    },
    blogPost: {
        id: "navigation.preview-panel-global-objects.blogPost",
        defaultMessage: "Confluence Blog Post"
    },
    page: {
        id: "navigation.preview-panel-global-objects.page",
        defaultMessage: "Confluence Page"
    },
    whiteboard: {
        id: "navigation.preview-panel-global-objects.whiteboard",
        defaultMessage: "Confluence Whiteboard"
    },
    object: {
        id: "navigation.preview-panel-global-objects.object",
        defaultMessage: "Assets Object"
    },
    loomVideo: {
        id: "navigation.preview-panel-global-objects.loomVideo",
        defaultMessage: "Loom Video"
    },
    loomVideoIcon: {
        id: "navigation.preview-panel-global-objects.loomVideoIcon",
        defaultMessage: "Loom Video Icon"
    }
});
var $7460fd5d96862093$export$2e2bcd8739ae039 = $7460fd5d96862093$var$_default_1;












var $bPFqZ = parcelRequire("bPFqZ");














var $RfroO = parcelRequire("RfroO");


var $i1t43 = parcelRequire("i1t43");


var $5WTxQ = parcelRequire("5WTxQ");

var $kMhHg = parcelRequire("kMhHg");

var $fE1YT = parcelRequire("fE1YT");

var $bRCqW = parcelRequire("bRCqW");




var $15c8312dd943cc5a$exports = {};
$15c8312dd943cc5a$exports = new URL("ErrorGeneric.5fda5790.svg", import.meta.url).toString();





const $187f07fc6540d83d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorHeader: {
        id: "navigation.preview-panel-global-objects.panels.error-header",
        defaultMessage: "Can\u2019t load details"
    },
    errorDescription: {
        id: "navigation.preview-panel-global-objects.panels.error-description",
        defaultMessage: "We\u2019ve got all hands on deck working to get you back up and running. For more information, <link>check our status page</link>."
    }
});


const $ab07d1dc0c3a9ca3$var$styles = {
    body: "_0LQT5EGXk2 _03SyCPGXk2 _46hvQmNHnM _0xmtkoNHnM"
};
const $ab07d1dc0c3a9ca3$export$9f31ac9d4b42e91c = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { url: url, name: name, icon: icon } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    let t1;
    if ($[0] !== icon || $[1] !== name) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $bRCqW.PreviewPanelTitle), {
            title: name,
            icon: icon
        });
        $[0] = icon;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== close || $[4] !== t1 || $[5] !== url) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $fE1YT.PreviewPanelHeader), {
            onClose: close,
            url: url
        }, t1);
        $[3] = close;
        $[4] = t1;
        $[5] = url;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== formatMessage) {
        t3 = formatMessage((0, $187f07fc6540d83d$export$defe85febe8b728c).errorHeader);
        $[7] = formatMessage;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== formatMessage) {
        t4 = formatMessage((0, $187f07fc6540d83d$export$defe85febe8b728c).errorDescription, {
            link: $ab07d1dc0c3a9ca3$var$_temp
        });
        $[9] = formatMessage;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t3 || $[12] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $kMhHg.PreviewPanelBody), {
            styles: $ab07d1dc0c3a9ca3$var$styles.body
        }, /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
            header: t3,
            description: t4,
            headingLevel: 2,
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($15c8312dd943cc5a$exports)))
        }));
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t2 || $[15] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $5WTxQ.PreviewPanel), null, t2, t5);
        $[14] = t2;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ url: url, name: name, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    return /*#__PURE__*/ $cozmU.createElement((0, $5WTxQ.PreviewPanel), null, /*#__PURE__*/ $cozmU.createElement((0, $fE1YT.PreviewPanelHeader), {
        onClose: close,
        url: url
    }, /*#__PURE__*/ $cozmU.createElement((0, $bRCqW.PreviewPanelTitle), {
        title: name,
        icon: icon
    })), /*#__PURE__*/ $cozmU.createElement((0, $kMhHg.PreviewPanelBody), {
        styles: $ab07d1dc0c3a9ca3$var$styles.body
    }, /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
        header: formatMessage((0, $187f07fc6540d83d$export$defe85febe8b728c).errorHeader),
        description: formatMessage((0, $187f07fc6540d83d$export$defe85febe8b728c).errorDescription, {
            link: (chunks)=>/*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                    href: "https://status.atlassian.com/"
                }, chunks)
        }),
        headingLevel: 2,
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($15c8312dd943cc5a$exports)))
    })));
});
function $ab07d1dc0c3a9ca3$var$_temp(chunks) {
    return /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        href: "https://status.atlassian.com/"
    }, chunks);
}












var $hekY6 = parcelRequire("hekY6");

















var $5tX23 = parcelRequire("5tX23");

const $12eaa30b38f0cfe7$var$styles = {
    body: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _2WAcuGIZbP _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO",
    skeleton: "_0bjKvDKxmn _3iDTPbQ4SZ _0KLXruGsB2 _0jFU0VSPN1",
    skeletonRow1: "_39xV02N91d",
    skeletonRow2: "_39xV02ygnw",
    skeletonRow3: "_39xV02gE1Q",
    skeletonRow4: "_39xV02iLlu"
};
const $12eaa30b38f0cfe7$export$97ea7ee86eec0667 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { url: url, name: name, icon: icon } = t0;
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { canNavigateBack: canNavigateBack, navigateBack: navigateBack } = (0, $5tX23.usePreviewPanelsNavigation)();
    let t1;
    if ($[0] !== canNavigateBack || $[1] !== navigateBack) {
        t1 = canNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") ? navigateBack : undefined;
        $[0] = canNavigateBack;
        $[1] = navigateBack;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== icon || $[4] !== name) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $bRCqW.PreviewPanelTitle), {
            title: name,
            icon: icon
        });
        $[3] = icon;
        $[4] = name;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== close || $[7] !== t1 || $[8] !== t2 || $[9] !== url) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $fE1YT.PreviewPanelHeader), {
            onClose: close,
            onNavigateBack: t1,
            url: url
        }, t2);
        $[6] = close;
        $[7] = t1;
        $[8] = t2;
        $[9] = url;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $kMhHg.PreviewPanelBody), {
            styles: $12eaa30b38f0cfe7$var$styles.body
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $12eaa30b38f0cfe7$var$styles.skeleton,
                $12eaa30b38f0cfe7$var$styles.skeletonRow1
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $12eaa30b38f0cfe7$var$styles.skeleton,
                $12eaa30b38f0cfe7$var$styles.skeletonRow2
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $12eaa30b38f0cfe7$var$styles.skeleton,
                $12eaa30b38f0cfe7$var$styles.skeletonRow3
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $12eaa30b38f0cfe7$var$styles.skeleton,
                $12eaa30b38f0cfe7$var$styles.skeletonRow4
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $12eaa30b38f0cfe7$var$styles.skeleton,
                $12eaa30b38f0cfe7$var$styles.skeletonRow1
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $12eaa30b38f0cfe7$var$styles.skeleton,
                $12eaa30b38f0cfe7$var$styles.skeletonRow2
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $12eaa30b38f0cfe7$var$styles.skeleton,
                $12eaa30b38f0cfe7$var$styles.skeletonRow3
            ])
        }), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $12eaa30b38f0cfe7$var$styles.skeleton,
                $12eaa30b38f0cfe7$var$styles.skeletonRow4
            ])
        }));
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t3) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $5WTxQ.PreviewPanel), null, t3, t4);
        $[12] = t3;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
} : ({ url: url, name: name, icon: icon })=>{
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { canNavigateBack: canNavigateBack, navigateBack: navigateBack } = (0, $5tX23.usePreviewPanelsNavigation)();
    return /*#__PURE__*/ $cozmU.createElement((0, $5WTxQ.PreviewPanel), null, /*#__PURE__*/ $cozmU.createElement((0, $fE1YT.PreviewPanelHeader), {
        onClose: close,
        onNavigateBack: canNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') ? navigateBack : undefined,
        url: url
    }, /*#__PURE__*/ $cozmU.createElement((0, $bRCqW.PreviewPanelTitle), {
        title: name,
        icon: icon
    })), /*#__PURE__*/ $cozmU.createElement((0, $kMhHg.PreviewPanelBody), {
        styles: $12eaa30b38f0cfe7$var$styles.body
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $12eaa30b38f0cfe7$var$styles.skeleton,
            $12eaa30b38f0cfe7$var$styles.skeletonRow1
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $12eaa30b38f0cfe7$var$styles.skeleton,
            $12eaa30b38f0cfe7$var$styles.skeletonRow2
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $12eaa30b38f0cfe7$var$styles.skeleton,
            $12eaa30b38f0cfe7$var$styles.skeletonRow3
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $12eaa30b38f0cfe7$var$styles.skeleton,
            $12eaa30b38f0cfe7$var$styles.skeletonRow4
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $12eaa30b38f0cfe7$var$styles.skeleton,
            $12eaa30b38f0cfe7$var$styles.skeletonRow1
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $12eaa30b38f0cfe7$var$styles.skeleton,
            $12eaa30b38f0cfe7$var$styles.skeletonRow2
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $12eaa30b38f0cfe7$var$styles.skeleton,
            $12eaa30b38f0cfe7$var$styles.skeletonRow3
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $12eaa30b38f0cfe7$var$styles.skeleton,
            $12eaa30b38f0cfe7$var$styles.skeletonRow4
        ])
    })));
});


const $13fbb0cc246d4c2d$var$emptyEntryPointProps = {};
const $13fbb0cc246d4c2d$export$2ace74dd551e05c1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { entryPoint: entryPoint, preloadedEntryPointReference: preloadedEntryPointReference, runtimeProps: t1, globalObject: globalObject } = t0;
    const runtimeProps = t1 === undefined ? $13fbb0cc246d4c2d$var$emptyEntryPointProps : t1;
    let t2;
    if ($[0] !== entryPoint.root) {
        t2 = entryPoint.root.getModuleName() || "unknown";
        $[0] = entryPoint.root;
        $[1] = t2;
    } else t2 = $[1];
    const id = t2;
    let t3;
    let t4;
    if ($[2] !== globalObject) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12eaa30b38f0cfe7$export$97ea7ee86eec0667), globalObject);
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ab07d1dc0c3a9ca3$export$9f31ac9d4b42e91c), globalObject);
        $[2] = globalObject;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] !== id || $[6] !== preloadedEntryPointReference || $[7] !== runtimeProps || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
            id: id,
            entryPointReference: preloadedEntryPointReference,
            fallback: t3,
            errorFallback: t4,
            runtimeProps: runtimeProps
        });
        $[5] = id;
        $[6] = preloadedEntryPointReference;
        $[7] = runtimeProps;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ entryPoint: entryPoint, preloadedEntryPointReference: preloadedEntryPointReference, runtimeProps: runtimeProps = $13fbb0cc246d4c2d$var$emptyEntryPointProps, globalObject: globalObject })=>{
    const id = (0, $cozmU.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
        id: id,
        entryPointReference: preloadedEntryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12eaa30b38f0cfe7$export$97ea7ee86eec0667), globalObject),
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ab07d1dc0c3a9ca3$export$9f31ac9d4b42e91c), globalObject),
        runtimeProps: runtimeProps
    });
};















var $NF6kd = parcelRequire("NF6kd");


var $l7jo6 = parcelRequire("l7jo6");








var $IQ4Dz = parcelRequire("IQ4Dz");





























const $206ea03682f91494$export$a62b229a34bacff7 = (ari)=>{
    const parsedAri = (0, $7avaU.AnyAri).parse(ari);
    return `${parsedAri.resourceOwner}-${parsedAri.resourceType}`;
};
const $206ea03682f91494$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $206ea03682f91494$export$5b60458e6ab1ba54 = (value)=>{
    if (!(0, $9324e169fd2f8d87$export$cec6f7cb9c99f251).includes(value)) throw new Error(`Unsupported global object type: ${value}`);
    return value;
};
const $206ea03682f91494$export$4e691bca3211cc2f = (url, supportedObjects, rootSourceScreen)=>{
    try {
        const urlObj = new URL(url);
        if ((0, $iDrrr.fg)('pol-21166-fix-404-on-jpd-preview')) {
            if ($206ea03682f91494$var$isJpdObject(urlObj)) return $206ea03682f91494$var$buildJpdEmbedUrl(urlObj);
        }
        // Ensure there's no trailing slash before appending '/embed'
        urlObj.pathname = urlObj.pathname.replace(/\/$/, '') + '/embed';
        // Add previewPanels to existing search params
        urlObj.searchParams.set('previewPanels', supportedObjects.join(','));
        // Availability check only — this decides whether to append the previewRootSourceScreen
        // URL param, NOT whether the user is accessing the Capacity planning experience. We
        // therefore read the GA experiment WITHOUT firing a Statsig exposure
        // (fireExperimentExposure: false); exposure is fired at the point the user actually
        // opens the Capacity experience, keeping the GA experiment's population clean.
        //
        // The OR still short-circuits: when the legacy EAP gate is ON the experiment is never
        // read at all. EAP customers remain unconditionally enabled.
        if (rootSourceScreen && ((0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
            fireExperimentExposure: false
        }))) urlObj.searchParams.set('previewRootSourceScreen', rootSourceScreen);
        // Return the full URL as a string
        return urlObj.toString();
    } catch  {
        // Fallback for invalid URLs.
        //
        // Availability check only (same semantics as the happy path above): this decides
        // whether to append previewRootSource, NOT whether the user is accessing the Capacity
        // planning experience. We read the GA experiment WITHOUT firing a Statsig exposure
        // (fireExperimentExposure: false). The OR still short-circuits when the legacy EAP gate
        // is ON, preserving a clean GA-experiment population.
        if ((0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
            fireExperimentExposure: false
        })) {
            const encodedRootSource = rootSourceScreen ? `&previewRootSource=${encodeURIComponent(rootSourceScreen)}` : '';
            return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}${encodedRootSource}`;
        } else return `${url}/embed?previewPanels=${encodeURIComponent(supportedObjects.join(','))}`;
    }
};
const $206ea03682f91494$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost') || hostname.includes('jira-dev')) return (0, $l7jo6.envType).DEV;
    return (0, $l7jo6.envType).PROD;
};
const $206ea03682f91494$var$isJpdObject = (urlObj)=>{
    return urlObj.pathname.includes('/jira/polaris/projects/');
};
const $206ea03682f91494$export$f59daa7c22f639ca = (ari)=>{
    try {
        return (0, $7avaU.AnyAri).parse(ari).cloudId || undefined;
    } catch  {
        return undefined;
    }
};
const $206ea03682f91494$var$buildJpdEmbedUrl = (urlObj)=>{
    const ideaKey = urlObj.searchParams.get('selectedIssue');
    urlObj.searchParams.delete('selectedIssue');
    urlObj.pathname = `/browse/${ideaKey}/embed`;
    return urlObj.toString();
};
const $206ea03682f91494$export$9e4592d635e5db5b = (ari, enabled)=>{
    const panelType = $206ea03682f91494$export$a62b229a34bacff7(ari);
    const panelEnabled = (enabled ?? true) && (0, $9324e169fd2f8d87$export$cec6f7cb9c99f251).includes(panelType);
    return panelEnabled;
};


const $4104ac35321558b9$var$styles = {
    iframe: "_30huDKYbGa _39xV02N91d _0jFU0VN91d",
    body: "_3iDTPbQ4SZ _2O5Vij7dHp _2WAcuGIZbP"
};
const $4104ac35321558b9$export$6c67178058384ea6 = (ari)=>{
    if (!ari || typeof ari !== 'string' || !ari.startsWith('ari:cloud:jira:')) return undefined;
    const parts = ari.split(':');
    if (parts.length !== 5) return undefined;
    const cloudId = parts[3];
    if (!cloudId) return undefined;
    return cloudId;
};
const $4104ac35321558b9$export$83f0623b6f97b032 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { url: url, iframeUrl: iframeUrl, name: name, icon: icon, panelType: panelType, product: product, parentProduct: parentProduct, ari: ari, analyticsAttributes: analyticsAttributes } = t0;
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { canNavigateBack: canNavigateBack, navigateBack: navigateBack } = (0, $5tX23.usePreviewPanelsNavigation)();
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)();
    let t1;
    if ($[0] !== ari) {
        t1 = ari ?? $4104ac35321558b9$export$6c67178058384ea6(ari);
        $[0] = ari;
        $[1] = t1;
    } else t1 = $[1];
    const cloudId = t1;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    let t2;
    let t3;
    if ($[2] !== cloudId || $[3] !== product) {
        t2 = ()=>{
            setAnalyticsClient(()=>{
                const analyticsClient_0 = new (0, $NF6kd.default)({
                    product: product,
                    env: (0, $206ea03682f91494$export$4acedbb0ac692186)(window.location.hostname),
                    origin: (0, $l7jo6.originType).WEB
                });
                if (cloudId) analyticsClient_0?.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, cloudId);
                return analyticsClient_0;
            });
        };
        t3 = [
            product,
            cloudId
        ];
        $[2] = cloudId;
        $[3] = product;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    bb0: {
        if (!iframeUrl || !colorMode) {
            t4 = iframeUrl;
            break bb0;
        }
        let t5;
        if ($[6] !== colorMode || $[7] !== iframeUrl) {
            const url_0 = new URL(iframeUrl, window.location.origin);
            url_0.searchParams.set("themeMode", colorMode);
            t5 = url_0.toString();
            $[6] = colorMode;
            $[7] = iframeUrl;
            $[8] = t5;
        } else t5 = $[8];
        t4 = t5;
    }
    const iframeSrc = t4;
    let t5;
    if ($[9] !== canNavigateBack || $[10] !== navigateBack) {
        t5 = canNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") ? navigateBack : undefined;
        $[9] = canNavigateBack;
        $[10] = navigateBack;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== icon || $[13] !== name) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $bRCqW.PreviewPanelTitle), {
            title: name,
            icon: icon
        });
        $[12] = icon;
        $[13] = name;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== analyticsClient || $[16] !== close || $[17] !== panelType || $[18] !== parentProduct || $[19] !== t5 || $[20] !== t6 || $[21] !== url) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $fE1YT.PreviewPanelHeader), {
            onClose: close,
            onNavigateBack: t5,
            url: url,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsClient: analyticsClient
        }, t6);
        $[15] = analyticsClient;
        $[16] = close;
        $[17] = panelType;
        $[18] = parentProduct;
        $[19] = t5;
        $[20] = t6;
        $[21] = url;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== analyticsAttributes) {
        t8 = (0, $iDrrr.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
            fireExperimentExposure: false
        }) ? {
            analyticsAttributes: analyticsAttributes
        } : {};
        $[23] = analyticsAttributes;
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $hekY6.default)([
            $4104ac35321558b9$var$styles.iframe
        ]);
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[26] !== iframeSrc || $[27] !== name) {
        t10 = /*#__PURE__*/ $cozmU.createElement("iframe", {
            src: iframeSrc,
            title: name,
            className: t9
        });
        $[26] = iframeSrc;
        $[27] = name;
        $[28] = t10;
    } else t10 = $[28];
    let t11;
    if ($[29] !== analyticsClient || $[30] !== panelType || $[31] !== parentProduct || $[32] !== t10 || $[33] !== t8) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $kMhHg.PreviewPanelBody), {
            styles: $4104ac35321558b9$var$styles.body,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsClient: analyticsClient,
            ...t8
        }, t10);
        $[29] = analyticsClient;
        $[30] = panelType;
        $[31] = parentProduct;
        $[32] = t10;
        $[33] = t8;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== t11 || $[36] !== t7) {
        t12 = /*#__PURE__*/ $cozmU.createElement((0, $5WTxQ.PreviewPanel), null, t7, t11);
        $[35] = t11;
        $[36] = t7;
        $[37] = t12;
    } else t12 = $[37];
    return t12;
} : ({ url: url, iframeUrl: iframeUrl, name: name, icon: icon, panelType: panelType, product: product, parentProduct: parentProduct, ari: ari, analyticsAttributes: analyticsAttributes })=>{
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { canNavigateBack: canNavigateBack, navigateBack: navigateBack } = (0, $5tX23.usePreviewPanelsNavigation)();
    const [analyticsClient, setAnalyticsClient] = (0, $cozmU.useState)();
    const cloudId = ari ?? $4104ac35321558b9$export$6c67178058384ea6(ari);
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    (0, $cozmU.useEffect)(()=>{
        setAnalyticsClient(()=>{
            let analyticsClient_0 = new (0, $NF6kd.default)({
                product: product,
                env: (0, $206ea03682f91494$export$4acedbb0ac692186)(window.location.hostname),
                origin: (0, $l7jo6.originType).WEB
            });
            if (cloudId) analyticsClient_0?.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, cloudId);
            return analyticsClient_0;
        });
    }, [
        product,
        cloudId
    ]); // Create iframe URL with theme parameter
    const iframeSrc = (0, $cozmU.useMemo)(()=>{
        if (!iframeUrl || !colorMode) return iframeUrl;
        const url_0 = new URL(iframeUrl, window.location.origin);
        url_0.searchParams.set('themeMode', colorMode);
        return url_0.toString();
    }, [
        iframeUrl,
        colorMode
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $5WTxQ.PreviewPanel), null, /*#__PURE__*/ $cozmU.createElement((0, $fE1YT.PreviewPanelHeader), {
        onClose: close,
        onNavigateBack: canNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') ? navigateBack : undefined,
        url: url,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsClient: analyticsClient
    }, /*#__PURE__*/ $cozmU.createElement((0, $bRCqW.PreviewPanelTitle), {
        title: name,
        icon: icon
    })), /*#__PURE__*/ $cozmU.createElement((0, $kMhHg.PreviewPanelBody), {
        styles: $4104ac35321558b9$var$styles.body,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsClient: analyticsClient,
        ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? {
            analyticsAttributes: analyticsAttributes
        } : {}
    }, /*#__PURE__*/ $cozmU.createElement("iframe", {
        src: iframeSrc,
        title: name,
        className: (0, $hekY6.default)([
            $4104ac35321558b9$var$styles.iframe
        ])
    })));
});









var $aBKty = parcelRequire("aBKty");

// src/jira/site/types.ts
var $8ac0e5c8b2cbf8ed$export$b7d590981b504412 = "jira", $8ac0e5c8b2cbf8ed$export$886165a991f21644 = "site";



var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/jira/site/manifest.ts
var $dbe612872f014897$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $8ac0e5c8b2cbf8ed$export$b7d590981b504412),
    resourceType: (0, $8ac0e5c8b2cbf8ed$export$886165a991f21644),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $dbe612872f014897$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $dbe612872f014897$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $dbe612872f014897$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $dbe612872f014897$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $dbe612872f014897$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $dbe612872f014897$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $dbe612872f014897$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};


/**
 * @generated SignedSource<<64da99bd55cf46ef1502fcbf0a421778>>
 * @relayHash 638a8927b678c956f62e66909b130468
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fddcba2c730fed863e19037f3b322032a2e6e9d261bc28033d24218f693a6d43
const $82fcf17ec48a4fe1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "anchorAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "anchorAri"
                }
            ],
            "concreteType": "AdminUnitLinkedResource",
            "kind": "LinkedField",
            "name": "admin_unitLinkedResource",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "after",
                            "variableName": "after"
                        },
                        {
                            "kind": "Variable",
                            "name": "filter",
                            "variableName": "filter"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "AdminUnitLinkedConnection",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AdminUnitLinkedEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AdminUnitLinkedTo",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUnitLinkedResourceIdsQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUnitLinkedResourceIdsQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "id": "fddcba2c730fed863e19037f3b322032a2e6e9d261bc28033d24218f693a6d43",
            "metadata": {},
            "name": "useUnitLinkedResourceIdsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$82fcf17ec48a4fe1$var$node.hash = "aa2b61565fa97898d0b012b6058e4937";
var $82fcf17ec48a4fe1$export$2e2bcd8739ae039 = $82fcf17ec48a4fe1$var$node;









var $lBg95 = parcelRequire("lBg95");

const $8d44da98defcaa45$var$DEFAULT_PAGE_SIZE = 50;
// Upper bound on pages followed in a single fetch, guarding against a backend
// that never reports `hasNextPage: false`.
const $8d44da98defcaa45$var$MAX_PAGES = 1000;
// A rejected Relay `fetchQuery` promise carries the GraphQL errors on
// `error.source.errors`.
const $8d44da98defcaa45$var$getAggErrors = (error)=>{
    const source = error?.source;
    return Array.isArray(source?.errors) ? source.errors : [];
};
const $8d44da98defcaa45$export$b0c02cbba07653c6 = (relayEnvironment, anchorResourceAri, options)=>{
    const atis = options?.atis;
    const enabled = options?.enabled ?? true;
    const pageSize = options?.pageSize ?? $8d44da98defcaa45$var$DEFAULT_PAGE_SIZE;
    // Content-stable so a fresh `atis` array with identical contents does not
    // re-run the effect below.
    const atisKey = JSON.stringify(atis ?? []);
    const atisFilter = (0, $cozmU.useMemo)(()=>JSON.parse(atisKey), [
        atisKey
    ]);
    const [state, setState] = (0, $cozmU.useState)({
        linkedResourceIds: [],
        loading: enabled && Boolean(anchorResourceAri),
        error: false
    });
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || !anchorResourceAri) {
            setState({
                linkedResourceIds: [],
                loading: false,
                error: false
            });
            return;
        }
        // Closure flag (not a shared ref) so a stale in-flight fetch resolving after
        // a newer effect run cannot overwrite state for a newer ARI / filter.
        let cancelled = false;
        setState({
            linkedResourceIds: [],
            loading: true,
            error: false
        });
        const fetchPage = (after)=>(0, $6SsN4.fetchQuery)(relayEnvironment, (0, $82fcf17ec48a4fe1$export$2e2bcd8739ae039), {
                anchorAri: anchorResourceAri,
                after: after,
                first: pageSize,
                filter: {
                    atis: atisFilter
                }
            }, {
                fetchPolicy: 'store-or-network'
            }).toPromise();
        // Walk the connection cursor until the server reports no further pages,
        // accumulating every linked-resource ARI across pages.
        const fetchAllPages = async ()=>{
            const ids = [];
            const seenCursors = new Set();
            let after = null;
            let hasNextPage = true;
            for(let page = 0; hasNextPage && page < $8d44da98defcaa45$var$MAX_PAGES; page++){
                const result = await fetchPage(after);
                const connection = result?.admin_unitLinkedResource?.links;
                for (const edge of connection?.edges ?? []){
                    const id = edge?.node?.id;
                    if (typeof id === 'string') ids.push(id);
                }
                const { hasNextPage: next, endCursor: endCursor } = connection?.pageInfo ?? {};
                // Stop if there is no further page, or the cursor does not advance
                // (missing or repeated) — following it would loop forever.
                hasNextPage = Boolean(next && endCursor && !seenCursors.has(endCursor));
                if (hasNextPage && endCursor) {
                    seenCursors.add(endCursor);
                    after = endCursor;
                }
            }
            return ids;
        };
        fetchAllPages().then((ids)=>{
            if (cancelled) return;
            setState({
                linkedResourceIds: ids,
                loading: false,
                error: false
            });
        }).catch((err)=>{
            if (cancelled) return;
            // UNAUTHENTICATED is expected on anonymous-reachable routes (the query
            // requires a session), so treat it as a benign empty result, not an error.
            const error = !(0, $lBg95.isUnauthenticated)($8d44da98defcaa45$var$getAggErrors(err));
            setState({
                linkedResourceIds: [],
                loading: false,
                error: error
            });
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        anchorResourceAri,
        atisFilter,
        enabled,
        pageSize,
        relayEnvironment
    ]);
    return state;
};


const $429d4a34c1ea7034$var$anchorBuilder = {
    jira: (siteId)=>(0, $dbe612872f014897$export$6c0f81f222d09301).create({
            siteId: siteId
        }).toString(),
    confluence: (siteId)=>(0, $aBKty.ConfluenceSiteAri).create({
            siteId: siteId
        }).toString()
};
const $429d4a34c1ea7034$var$buildAnchorAri = (product, cloudId)=>{
    const build = $429d4a34c1ea7034$var$anchorBuilder[product];
    return build && cloudId ? build(cloudId) : '';
};
const $429d4a34c1ea7034$var$extractLinkedCloudIds = (linkedResourceIds)=>{
    const cloudIds = new Set();
    for (const ari of linkedResourceIds)try {
        const parsed = (0, $7avaU.AnyAri).parse(ari);
        if (parsed.resourceType === 'site' && parsed.resourceId) cloudIds.add(parsed.resourceId);
    } catch  {
    // Ignore unparseable ARIs.
    }
    return cloudIds;
};
const $429d4a34c1ea7034$export$6dbac3a5ce6f0cf8 = (relayEnvironment, product, cloudId)=>{
    const anchorAri = (0, $cozmU.useMemo)(()=>$429d4a34c1ea7034$var$buildAnchorAri(product, cloudId), [
        product,
        cloudId
    ]);
    const [hasRequestedFetch, setHasRequestedFetch] = (0, $cozmU.useState)(false);
    const { linkedResourceIds: linkedResourceIds, loading: loading, error: error } = (0, $8d44da98defcaa45$export$b0c02cbba07653c6)(relayEnvironment, anchorAri, {
        enabled: hasRequestedFetch
    });
    const linkedCloudIds = (0, $cozmU.useMemo)(()=>$429d4a34c1ea7034$var$extractLinkedCloudIds(linkedResourceIds), [
        linkedResourceIds
    ]);
    // Read via a ref so isCloudIdInSameUnit keeps a stable identity across fetches.
    const stateRef = (0, $cozmU.useRef)({
        linkedCloudIds: linkedCloudIds,
        loading: loading,
        error: error,
        hasRequestedFetch: hasRequestedFetch
    });
    stateRef.current = {
        linkedCloudIds: linkedCloudIds,
        loading: loading,
        error: error,
        hasRequestedFetch: hasRequestedFetch
    };
    const fetchScheduledRef = (0, $cozmU.useRef)(false);
    const isCloudIdInSameUnit = (0, $cozmU.useCallback)((targetCloudId)=>{
        const { linkedCloudIds: linkedCloudIds_0, loading: loading_0, error: error_0, hasRequestedFetch: hasRequestedFetch_0 } = stateRef.current;
        if (!anchorAri || !targetCloudId || targetCloudId === cloudId) return true;
        // This runs during the consumer's render, where React forbids setState.
        // Defer it to a microtask so the fetch is triggered after render finishes.
        if (!hasRequestedFetch_0 && !fetchScheduledRef.current) {
            fetchScheduledRef.current = true;
            queueMicrotask(()=>setHasRequestedFetch(true));
        }
        // Fail open until the fetch has been requested and settled with data.
        if (!hasRequestedFetch_0 || loading_0 || error_0) return true;
        return linkedCloudIds_0.has(targetCloudId);
    }, [
        anchorAri,
        cloudId
    ]);
    return {
        isCloudIdInSameUnit: isCloudIdInSameUnit
    };
};



const $908f001dc38742af$var$parseGlobalObjectAri = (ari)=>{
    try {
        const parsedAri = (0, $7avaU.AnyAri).parse(ari);
        return {
            cloudId: parsedAri.cloudId || undefined,
            globalObjectType: `${parsedAri.resourceOwner}-${parsedAri.resourceType}`
        };
    } catch  {
        return {
            cloudId: undefined,
            globalObjectType: undefined
        };
    }
};
/**
 * Stable stub for the legacy (gate-off) behaviour, where the cross-unit restriction signal does
 * not exist — always reports "not restricted" so nothing is suppressed. Declared at module scope
 * so it keeps a stable reference across renders (avoids invalidating consumers' `useMemo`s that
 * depend on `isPreviewRestricted`).
 */ const $908f001dc38742af$var$NOT_PREVIEW_RESTRICTED = ()=>false;
const $908f001dc38742af$export$11fc68d08b35b1b0 = (product, cloudId, options)=>{
    const { enabled: enabled = true, activityTabSlot: activityTabSlot, supportedObjects: supportedObjects = (0, $9324e169fd2f8d87$export$cec6f7cb9c99f251), analyticsAttributes: analyticsAttributes, maxWidth: maxWidth, rootSourceScreen: rootSourceScreen, environmentProvider: environmentProviderOverride } = options ?? {};
    const defaultEnvironmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const environmentProvider = environmentProviderOverride ?? defaultEnvironmentProvider;
    const relayEnvironment = (0, $cozmU.useMemo)(()=>environmentProvider.getEnvironment({}), [
        environmentProvider
    ]);
    const { isCloudIdInSameUnit: isCloudIdInSameUnit } = (0, $429d4a34c1ea7034$export$6dbac3a5ce6f0cf8)(relayEnvironment, product, cloudId);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { open: open } = (0, $lRhY3.usePreviewPanelsActions)();
    // Shared object-type/enablement preconditions (no cross-unit check) so the
    // "available" and "restricted" signals cannot drift apart.
    const getPanelEligibility = (0, $cozmU.useCallback)(({ ari: ari })=>{
        const { globalObjectType: panelType, cloudId: targetCloudId } = $908f001dc38742af$var$parseGlobalObjectAri(ari);
        if (!panelType) return {
            eligible: false,
            targetCloudId: targetCloudId
        };
        const panelEnabled = enabled && supportedObjects.includes(panelType);
        if (!panelEnabled) return {
            eligible: false,
            targetCloudId: targetCloudId
        };
        return {
            eligible: true,
            targetCloudId: targetCloudId
        };
    }, [
        enabled,
        supportedObjects
    ]);
    const isPreviewPanelAvailable = (0, $cozmU.useCallback)(({ ari: ari_0 })=>{
        const { eligible: eligible, targetCloudId: targetCloudId_0 } = getPanelEligibility({
            ari: ari_0
        });
        if (!eligible) return false;
        return isCloudIdInSameUnit(targetCloudId_0);
    }, [
        getPanelEligibility,
        isCloudIdInSameUnit
    ]);
    // True only for a panel-eligible object in a different unit.
    const isPreviewRestricted = (0, $cozmU.useCallback)(({ ari: ari_1 })=>{
        const { eligible: eligible_0, targetCloudId: targetCloudId_1 } = getPanelEligibility({
            ari: ari_1
        });
        if (!eligible_0) return false;
        return !isCloudIdInSameUnit(targetCloudId_1);
    }, [
        getPanelEligibility,
        isCloudIdInSameUnit
    ]);
    const openPreviewPanel = (0, $cozmU.useCallback)(({ url: url, ari: ari_2, name: name, parentProduct: parentProduct, panelData: panelData, onOpen: onOpen, organizationId: organizationId = '' }, openOptions)=>{
        let globalObjectType;
        // Restricted (cross-unit) resources are valid types we decline to preview.
        if (isPreviewRestricted({
            ari: ari_2
        })) return;
        globalObjectType = $908f001dc38742af$var$parseGlobalObjectAri(ari_2).globalObjectType;
        if (!globalObjectType || !isPreviewPanelAvailable({
            ari: ari_2
        })) throw new Error(`Preview panel for ${globalObjectType ?? 'unknown'} with ARI ${ari_2} is not supported.`);
        // Check if we're in an iframe (not the top-most frame)
        if ((0, $206ea03682f91494$export$9f140ed41af5108c)()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: url,
                    ari: ari_2,
                    name: name,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        let panelContent;
        let panelProduct;
        switch(globalObjectType){
            case 'jira-issue':
                const JiraIcon = product === 'jira' ? (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($f1iv3)));
                const title = formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).workItem);
                panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4104ac35321558b9$export$83f0623b6f97b032), {
                    name: title,
                    url: url,
                    iframeUrl: // Availability check only — this decides whether the embed URL carries the
                    // rootSourceScreen, NOT whether the user is accessing the Capacity
                    // planning experience. We therefore read the GA experiment WITHOUT
                    // firing a Statsig exposure (fireExperimentExposure: false); exposure is
                    // fired at the point the user actually opens the Capacity experience,
                    // keeping the GA experiment's population clean.
                    //
                    // The OR still short-circuits: when the legacy EAP gate is ON the
                    // experiment is never read at all. EAP customers remain unconditionally
                    // enabled.
                    (0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? (0, $206ea03682f91494$export$4e691bca3211cc2f)(url, supportedObjects, rootSourceScreen) : (0, $206ea03682f91494$export$4e691bca3211cc2f)(url, supportedObjects),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(JiraIcon, {
                        label: ""
                    }),
                    panelType: "jira-work-item",
                    product: "jira",
                    parentProduct: parentProduct,
                    ari: ari_2,
                    ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? {
                        analyticsAttributes: analyticsAttributes
                    } : {}
                });
                panelProduct = 'jira';
                break;
            case 'identity-team':
                {
                    const teamEntryPointReference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $13370b928e51f660$export$2e2bcd8739ae039), {
                        cloudId: cloudId
                    });
                    const teamPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $13370b928e51f660$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: teamEntryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            ari: ari_2,
                            cloudId: cloudId,
                            openPreviewPanel: openPreviewPanel
                        },
                        globalObject: {
                            name: formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).team),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dflgH))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? teamPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, teamPanel);
                    panelProduct = 'people';
                    break;
                }
            case 'townsquare-goal':
                {
                    const entryPointReference_2 = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $2020c81a177e1777$export$2e2bcd8739ae039), {
                        ari: ari_2
                    });
                    const goalPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $2020c81a177e1777$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: entryPointReference_2,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $3a838e14fe15d330$export$68d1d951742105ed)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).goal),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6CsCB))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? goalPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, goalPanel);
                    panelProduct = 'townsquare';
                    break;
                }
            case 'townsquare-project':
                {
                    const entryPointReference_1 = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $f5f05018b4a542da$export$2e2bcd8739ae039), {
                        ari: ari_2
                    });
                    const projectPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $f5f05018b4a542da$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: entryPointReference_1,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $3a838e14fe15d330$export$68d1d951742105ed)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).project),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? projectPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, projectPanel);
                    panelProduct = 'townsquare';
                    break;
                }
            case 'confluence-blogpost':
            case 'confluence-page':
                {
                    const isBlogPost = globalObjectType === 'confluence-blogpost';
                    const urlObj = new URL(url);
                    urlObj.searchParams.set('previewPanels', encodeURIComponent((0, $9324e169fd2f8d87$export$cec6f7cb9c99f251).join(',')));
                    const formattedUrl = urlObj.toString();
                    const entryPointReference_0 = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $57ad7e92d2bdb34f$export$a50c261b4b52f403), {});
                    panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $57ad7e92d2bdb34f$export$a50c261b4b52f403),
                        preloadedEntryPointReference: entryPointReference_0,
                        runtimeProps: {
                            url: formattedUrl,
                            parentProduct: product,
                            contentType: isBlogPost ? 'blogpost' : 'page',
                            panelData: panelData,
                            cloudId: cloudId
                        },
                        globalObject: {
                            name: formatMessage(isBlogPost ? (0, $7460fd5d96862093$export$2e2bcd8739ae039).blogPost : (0, $7460fd5d96862093$export$2e2bcd8739ae039).page),
                            url: formattedUrl,
                            icon: isBlogPost ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
                                label: ""
                            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'confluence-whiteboard':
                {
                    const entryPointReference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $57ad7e92d2bdb34f$export$a50c261b4b52f403), {});
                    panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $57ad7e92d2bdb34f$export$a50c261b4b52f403),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product
                        },
                        globalObject: {
                            name: formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).whiteboard),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'cmdb-object':
                {
                    const assetsEntryPointReference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $33101bec474714ae$export$2e2bcd8739ae039), {
                        cloudId: cloudId
                    });
                    // Gate on: per-open slot wins, hook-level option is the fallback.
                    // Gate off: keep the previous hook-level-only behavior.
                    const resolvedActivityTabSlot = (0, $iDrrr.fg)('roh_5641_preview_panel_per_open_activity_slot') ? openOptions?.activityTabSlot ?? activityTabSlot : activityTabSlot;
                    panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $33101bec474714ae$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: assetsEntryPointReference,
                        runtimeProps: {
                            activityTabSlot: resolvedActivityTabSlot,
                            url: url,
                            parentProduct: product,
                            ari: ari_2,
                            cloudId: cloudId,
                            organizationId: organizationId,
                            openPreviewPanel: openPreviewPanel
                        },
                        // These are fallback properties
                        globalObject: {
                            name: formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).object),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8OpiN))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'assetsPreviewPanel';
                    break;
                }
            default:
                throw new Error(`Unsupported global object type: ${globalObjectType}`);
        }
        open({
            panel: {
                id: ari_2,
                type: globalObjectType,
                content: ()=>panelContent,
                product: panelProduct,
                ...maxWidth && {
                    maxWidth: maxWidth
                }
            },
            ...(0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') ? {
                onOpen: onOpen
            } : {}
        });
    }, [
        isPreviewPanelAvailable,
        isPreviewRestricted,
        open,
        formatMessage,
        supportedObjects,
        environmentProvider,
        environmentProviderOverride,
        product,
        cloudId,
        activityTabSlot,
        analyticsAttributes,
        maxWidth,
        rootSourceScreen
    ]);
    return {
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        isPreviewRestricted: isPreviewRestricted,
        openPreviewPanel: openPreviewPanel
    };
};
const $908f001dc38742af$export$b86c9a4cc5423056 = (product, cloudId, options)=>{
    const { enabled: enabled = true, activityTabSlot: activityTabSlot, supportedObjects: supportedObjects = (0, $9324e169fd2f8d87$export$cec6f7cb9c99f251), analyticsAttributes: analyticsAttributes, maxWidth: maxWidth, rootSourceScreen: rootSourceScreen, environmentProvider: environmentProviderOverride } = options ?? {};
    const defaultEnvironmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const environmentProvider = environmentProviderOverride ?? defaultEnvironmentProvider;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { open: open } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelAvailable = (0, $cozmU.useCallback)(({ ari: ari })=>(0, $206ea03682f91494$export$9e4592d635e5db5b)(ari, enabled), [
        enabled
    ]);
    const openPreviewPanel = (0, $cozmU.useCallback)(({ url: url, ari: ari_0, name: name, parentProduct: parentProduct, panelData: panelData, onOpen: onOpen, organizationId: organizationId = '' }, openOptions)=>{
        const globalObjectType = (0, $206ea03682f91494$export$a62b229a34bacff7)(ari_0);
        if (!isPreviewPanelAvailable({
            ari: ari_0
        })) throw new Error(`Preview panel for ${globalObjectType} with ARI ${ari_0} is not supported.`);
        // Check if we're in an iframe (not the top-most frame)
        if ((0, $206ea03682f91494$export$9f140ed41af5108c)()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: url,
                    ari: ari_0,
                    name: name,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        let panelContent;
        let panelProduct;
        switch(globalObjectType){
            case 'jira-issue':
                const JiraIcon = product === 'jira' ? (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($f1iv3)));
                const title = formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).workItem);
                panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4104ac35321558b9$export$83f0623b6f97b032), {
                    name: title,
                    url: url,
                    iframeUrl: // Availability check only — this decides whether the embed URL carries the
                    // rootSourceScreen, NOT whether the user is accessing the Capacity
                    // planning experience. We therefore read the GA experiment WITHOUT
                    // firing a Statsig exposure (fireExperimentExposure: false); exposure is
                    // fired at the point the user actually opens the Capacity experience,
                    // keeping the GA experiment's population clean.
                    //
                    // The OR still short-circuits: when the legacy EAP gate is ON the
                    // experiment is never read at all. EAP customers remain unconditionally
                    // enabled.
                    (0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? (0, $206ea03682f91494$export$4e691bca3211cc2f)(url, supportedObjects, rootSourceScreen) : (0, $206ea03682f91494$export$4e691bca3211cc2f)(url, supportedObjects),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(JiraIcon, {
                        label: ""
                    }),
                    panelType: "jira-work-item",
                    product: "jira",
                    parentProduct: parentProduct,
                    ari: ari_0,
                    ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? {
                        analyticsAttributes: analyticsAttributes
                    } : {}
                });
                panelProduct = 'jira';
                break;
            case 'identity-team':
                {
                    const teamEntryPointReference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $13370b928e51f660$export$2e2bcd8739ae039), {
                        cloudId: cloudId
                    });
                    const teamPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $13370b928e51f660$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: teamEntryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            ari: ari_0,
                            cloudId: cloudId,
                            openPreviewPanel: openPreviewPanel
                        },
                        globalObject: {
                            name: formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).team),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dflgH))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? teamPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, teamPanel);
                    panelProduct = 'people';
                    break;
                }
            case 'townsquare-goal':
                {
                    const entryPointReference_2 = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $2020c81a177e1777$export$2e2bcd8739ae039), {
                        ari: ari_0
                    });
                    const goalPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $2020c81a177e1777$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: entryPointReference_2,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $3a838e14fe15d330$export$68d1d951742105ed)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).goal),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6CsCB))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? goalPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, goalPanel);
                    panelProduct = 'townsquare';
                    break;
                }
            case 'townsquare-project':
                {
                    const entryPointReference_1 = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $f5f05018b4a542da$export$2e2bcd8739ae039), {
                        ari: ari_0
                    });
                    const projectPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $f5f05018b4a542da$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: entryPointReference_1,
                        runtimeProps: {
                            url: url,
                            parentProduct: product,
                            cloudId: cloudId,
                            defaultTab: (0, $3a838e14fe15d330$export$68d1d951742105ed)(url)
                        },
                        globalObject: {
                            name: formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).project),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
                                label: ""
                            })
                        }
                    });
                    panelContent = environmentProviderOverride ? projectPanel : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, projectPanel);
                    panelProduct = 'townsquare';
                    break;
                }
            case 'confluence-blogpost':
            case 'confluence-page':
                {
                    const isBlogPost = globalObjectType === 'confluence-blogpost';
                    const urlObj = new URL(url);
                    urlObj.searchParams.set('previewPanels', encodeURIComponent((0, $9324e169fd2f8d87$export$cec6f7cb9c99f251).join(',')));
                    const formattedUrl = urlObj.toString();
                    const entryPointReference_0 = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $57ad7e92d2bdb34f$export$a50c261b4b52f403), {});
                    panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $57ad7e92d2bdb34f$export$a50c261b4b52f403),
                        preloadedEntryPointReference: entryPointReference_0,
                        runtimeProps: {
                            url: formattedUrl,
                            parentProduct: product,
                            contentType: isBlogPost ? 'blogpost' : 'page',
                            panelData: panelData,
                            cloudId: cloudId
                        },
                        globalObject: {
                            name: formatMessage(isBlogPost ? (0, $7460fd5d96862093$export$2e2bcd8739ae039).blogPost : (0, $7460fd5d96862093$export$2e2bcd8739ae039).page),
                            url: formattedUrl,
                            icon: isBlogPost ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
                                label: ""
                            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'confluence-whiteboard':
                {
                    const entryPointReference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $57ad7e92d2bdb34f$export$a50c261b4b52f403), {});
                    panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $57ad7e92d2bdb34f$export$a50c261b4b52f403),
                        preloadedEntryPointReference: entryPointReference,
                        runtimeProps: {
                            url: url,
                            parentProduct: product
                        },
                        globalObject: {
                            name: formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).whiteboard),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'confluencePreviewPanel';
                    break;
                }
            case 'cmdb-object':
                {
                    const assetsEntryPointReference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $33101bec474714ae$export$2e2bcd8739ae039), {
                        cloudId: cloudId
                    });
                    // Gate on: per-open slot wins, hook-level option is the fallback.
                    // Gate off: keep the previous hook-level-only behavior.
                    const resolvedActivityTabSlot = (0, $iDrrr.fg)('roh_5641_preview_panel_per_open_activity_slot') ? openOptions?.activityTabSlot ?? activityTabSlot : activityTabSlot;
                    panelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13fbb0cc246d4c2d$export$2ace74dd551e05c1), {
                        entryPoint: (0, $33101bec474714ae$export$2e2bcd8739ae039),
                        preloadedEntryPointReference: assetsEntryPointReference,
                        runtimeProps: {
                            activityTabSlot: resolvedActivityTabSlot,
                            url: url,
                            parentProduct: product,
                            ari: ari_0,
                            cloudId: cloudId,
                            organizationId: organizationId,
                            openPreviewPanel: openPreviewPanel
                        },
                        // These are fallback properties
                        globalObject: {
                            name: formatMessage((0, $7460fd5d96862093$export$2e2bcd8739ae039).object),
                            url: url,
                            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8OpiN))), {
                                label: ""
                            })
                        }
                    });
                    panelProduct = 'assetsPreviewPanel';
                    break;
                }
            default:
                throw new Error(`Unsupported global object type: ${globalObjectType}`);
        }
        open({
            panel: {
                id: ari_0,
                type: globalObjectType,
                content: ()=>panelContent,
                product: panelProduct,
                ...maxWidth && {
                    maxWidth: maxWidth
                }
            },
            ...(0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') ? {
                onOpen: onOpen
            } : {}
        });
    }, [
        isPreviewPanelAvailable,
        open,
        formatMessage,
        supportedObjects,
        environmentProvider,
        environmentProviderOverride,
        product,
        cloudId,
        activityTabSlot,
        analyticsAttributes,
        maxWidth,
        rootSourceScreen
    ]);
    return {
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        isPreviewRestricted: $908f001dc38742af$var$NOT_PREVIEW_RESTRICTED,
        openPreviewPanel: openPreviewPanel
    };
};
const $908f001dc38742af$var$isAllowedOrigin = (origin)=>{
    return origin === window.location.origin;
};
const $908f001dc38742af$export$3cfc2fe60a8f0a1c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (openPreviewPanel)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    let t1;
    if ($[0] !== openPreviewPanel) {
        t0 = ()=>{
            const handleMessage = (event)=>{
                if (!$908f001dc38742af$var$isAllowedOrigin(event.origin) && (0, $iDrrr.fg)("vuln-fix-adding-origin-validation-for-iframe-pp")) return;
                if (event.data?.type !== "OPEN_PREVIEW_PANEL") return;
                const { payload: payload } = event.data;
                if (payload?.url && payload?.ari && payload?.name) openPreviewPanel({
                    url: payload.url,
                    ari: payload.ari,
                    name: payload.name,
                    panelData: payload.panelData
                });
            };
            window.addEventListener("message", handleMessage);
            return ()=>{
                window.removeEventListener("message", handleMessage);
            };
        };
        t1 = [
            openPreviewPanel
        ];
        $[0] = openPreviewPanel;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : (openPreviewPanel)=>{
    // Listen for messages from iframes to open panels
    (0, $cozmU.useEffect)(()=>{
        const handleMessage = (event)=>{
            // Validate origin FIRST - reject messages from untrusted origins
            // Protected by feature flag: vuln-fix-adding-origin-validation-for-iframe-pp
            if (!$908f001dc38742af$var$isAllowedOrigin(event.origin) && (0, $iDrrr.fg)('vuln-fix-adding-origin-validation-for-iframe-pp')) return;
            // Only handle messages with the expected type
            if (event.data?.type !== 'OPEN_PREVIEW_PANEL') return;
            const { payload: payload } = event.data;
            if (payload?.url && payload?.ari && payload?.name) openPreviewPanel({
                url: payload.url,
                ari: payload.ari,
                name: payload.name,
                panelData: payload.panelData
            });
        };
        window.addEventListener('message', handleMessage);
        return ()=>{
            window.removeEventListener('message', handleMessage);
        };
    }, [
        openPreviewPanel
    ]);
};
const $908f001dc38742af$export$70bcacea0b970dee = (0, $2zVsi.functionWithCondition)(()=>(0, $iDrrr.fg)('preview_panel_unit_check'), $908f001dc38742af$export$11fc68d08b35b1b0, $908f001dc38742af$export$b86c9a4cc5423056);



var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $eToX6 = parcelRequire("eToX6");

/**
 * Resolves Confluence short links to canonical URLs for preview panels.
 * For Confluence short links (e.g., /wiki/x/ABC123), attempts to construct
 * the canonical URL from preview.href parameters.
 */ const $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl = (originalUrl, response)=>{
    const responseData = response?.data;
    const previewHref = responseData?.preview?.href;
    if (!previewHref) return originalUrl;
    try {
        const previewUrl = new URL(previewHref);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            return `https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`;
        }
    } catch  {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
// Helper function to check if previewPanels query parameter is present
const $88a4e0a84f25d5c3$var$hasPreviewPanelsParam = ()=>{
    try {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('previewPanels');
    } catch  {
        return false;
    }
};
const $88a4e0a84f25d5c3$var$noop = ()=>{
// this is intentional
};
const $88a4e0a84f25d5c3$export$b92594fec494137a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            supportedObjects: (0, $9324e169fd2f8d87$export$cec6f7cb9c99f251)
        };
        $[0] = t0;
    } else t0 = $[0];
    const { openPreviewPanel: openAtlasPreviewPanel } = (0, $908f001dc38742af$export$70bcacea0b970dee)((0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE, cloudId, t0);
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel } = (0, $Gq5Ho.useConfluencePagePreviewPanel)((0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE, cloudId);
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    let t1;
    if ($[1] !== cardContext || $[2] !== openAtlasPreviewPanel || $[3] !== openConfluencePagePreviewPanel || $[4] !== orgId) {
        const open = (t2)=>{
            const { url: url, ari: ari, panelData: panelData } = t2;
            let resolvedUrl = url;
            if (url.includes("/wiki/x/") && cardContext?.value?.store) {
                const cardState = cardContext.value.store.getState()[url];
                if (cardState?.details) resolvedUrl = $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl(url, cardState.details);
            }
            const name = (0, $7avaU.AnyAri).parse(ari).resourceType;
            const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
            if ((0, $eToX6.isInIframe)() && $88a4e0a84f25d5c3$var$hasPreviewPanelsParam()) {
                window.parent.postMessage({
                    type: "OPEN_PREVIEW_PANEL",
                    payload: {
                        url: resolvedUrl,
                        ari: ari,
                        name: formattedName,
                        panelData: panelData
                    }
                }, "*");
                return;
            }
            if ((0, $6B1vK.ConfluencePageAri).check(ari)) {
                const urlObj = new URL(resolvedUrl);
                urlObj.searchParams.set("previewPanels", encodeURIComponent((0, $9324e169fd2f8d87$export$cec6f7cb9c99f251).join(",")));
                openConfluencePagePreviewPanel(urlObj.toString(), $88a4e0a84f25d5c3$var$noop, panelData);
                return;
            }
            if ((0, $1RQo0.TownsquareGoalAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Goal",
                    parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $aLUFu.TownsquareProjectAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Project",
                    parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $fjKr7.JiraIssueAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Jira Work Item",
                    parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $iJxD8.IdentityTeamAri).check(ari)) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Team",
                    parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
            if ((0, $yx6Pm.CmdbObjectAri).check(ari) && (0, $9wGTI.fg)("open_preview_panel_for_assets_object_in_confluence")) {
                openAtlasPreviewPanel({
                    url: url,
                    ari: ari,
                    name: "Object",
                    organizationId: orgId,
                    parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
                });
                return;
            }
        };
        t1 = {
            open: open
        };
        $[1] = cardContext;
        $[2] = openAtlasPreviewPanel;
        $[3] = openConfluencePagePreviewPanel;
        $[4] = orgId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const supportedObjects = (0, $9324e169fd2f8d87$export$cec6f7cb9c99f251);
    const { openPreviewPanel: openAtlasPreviewPanel } = (0, $908f001dc38742af$export$70bcacea0b970dee)((0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE, cloudId, {
        supportedObjects: supportedObjects
    });
    const { openConfluencePagePreviewPanel: openConfluencePagePreviewPanel } = (0, $Gq5Ho.useConfluencePagePreviewPanel)((0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE, cloudId);
    const cardContext = (0, $9f1Yt.useSmartCardContext)();
    const open = ({ url: url, ari: ari, panelData: panelData })=>{
        let resolvedUrl = url;
        // Only resolve when url is Confluence short links
        if (url.includes('/wiki/x/') && cardContext?.value?.store) {
            const cardState = cardContext.value.store.getState()[url];
            if (cardState?.details) resolvedUrl = $88a4e0a84f25d5c3$var$resolveConfluencePreviewPanelUrl(url, cardState.details);
        }
        const name = (0, $7avaU.AnyAri).parse(ari).resourceType;
        const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
        if ((0, $eToX6.isInIframe)() && $88a4e0a84f25d5c3$var$hasPreviewPanelsParam()) {
            // Post message to parent frame to open the panel
            window.parent.postMessage({
                type: 'OPEN_PREVIEW_PANEL',
                payload: {
                    url: resolvedUrl,
                    ari: ari,
                    name: formattedName,
                    panelData: panelData
                }
            }, '*');
            return;
        }
        if ((0, $6B1vK.ConfluencePageAri).check(ari)) {
            const urlObj = new URL(resolvedUrl);
            urlObj.searchParams.set('previewPanels', encodeURIComponent(supportedObjects.join(',')));
            openConfluencePagePreviewPanel(urlObj.toString(), $88a4e0a84f25d5c3$var$noop, panelData);
            return;
        }
        if ((0, $1RQo0.TownsquareGoalAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Goal',
                parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $aLUFu.TownsquareProjectAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Project',
                parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $fjKr7.JiraIssueAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Jira Work Item',
                parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $iJxD8.IdentityTeamAri).check(ari)) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Team',
                parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
        if ((0, $yx6Pm.CmdbObjectAri).check(ari) && (0, $9wGTI.fg)('open_preview_panel_for_assets_object_in_confluence')) {
            openAtlasPreviewPanel({
                url: url,
                ari: ari,
                name: 'Object',
                organizationId: orgId,
                parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
            });
            return;
        }
    };
    return {
        open: open
    };
};
module.exports["useOpenPreviewPanel"] = $88a4e0a84f25d5c3$export$b92594fec494137a;

});

parcelRegister("yx6Pm", function(module, exports) {
// src/cmdb/object/types.ts
var $17097b586e99e279$export$49b9d2d1387741a7 = "cmdb", $17097b586e99e279$export$1a8140347f10ee2c = "object";



var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/cmdb/object/manifest.ts
var $067cdbdf2303fd1b$var$cmdbObjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $17097b586e99e279$export$49b9d2d1387741a7),
    resourceType: (0, $17097b586e99e279$export$1a8140347f10ee2c),
    resourceIdSlug: "{workspaceId}/{objectId}",
    resourceIdSegmentFormats: {
        workspaceId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        objectId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/cmdb/object/index.ts
var $067cdbdf2303fd1b$export$f88f1e43c97ce553 = class _CmdbObjectAri extends (0, $1gKSA.RegisteredAri) {
    get workspaceId() {
        return this._workspaceId;
    }
    get objectId() {
        return this._objectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $067cdbdf2303fd1b$var$cmdbObjectAriStaticOpts.qualifier,
            platformQualifier: $067cdbdf2303fd1b$var$cmdbObjectAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $067cdbdf2303fd1b$var$cmdbObjectAriStaticOpts.resourceOwner,
            resourceType: $067cdbdf2303fd1b$var$cmdbObjectAriStaticOpts.resourceType,
            resourceId: `${opts.workspaceId}/${opts.objectId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                objectId: opts.objectId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $067cdbdf2303fd1b$var$cmdbObjectAriStaticOpts);
        return new _CmdbObjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $067cdbdf2303fd1b$var$cmdbObjectAriStaticOpts);
        return new _CmdbObjectAri(opts);
    }
    getVariables() {
        return {
            workspaceId: this.workspaceId,
            objectId: this.objectId
        };
    }
    constructor(opts){
        super(opts), this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._objectId = opts.resourceIdSegmentValues.objectId;
    }
};
module.exports["CmdbObjectAri"] = $067cdbdf2303fd1b$export$f88f1e43c97ce553;

});

parcelRegister("dAzRS", function(module, exports) {
const $816e9ec045ae5d6e$export$bc4191f7b8dfa3a4 = {
    CONFLUENCE: 'confluence',
    HOME: 'home',
    JIRA: 'jira',
    TEAMS: 'teams'
};
module.exports["PARENT_PRODUCTS"] = $816e9ec045ae5d6e$export$bc4191f7b8dfa3a4;

});

parcelRegister("Gq5Ho", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lRhY3 = parcelRequire("lRhY3");


var $2w19Y = parcelRequire("2w19Y");

const $2e15ea96b280ebaf$export$46eb6ca3d43ca839 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (parentProduct, cloudId, onClose)=>{
    const $ = (0, $bDgLe.c)(10);
    const { open: open, close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    let t0;
    if ($[0] !== cloudId || $[1] !== open || $[2] !== parentProduct) {
        t0 = (url, onOpen, panelData)=>{
            open({
                panel: {
                    id: `confluence-page-preview-panel_${url.split("/").pop()}`,
                    type: "confluence-page",
                    content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2w19Y.default), {
                            props: {
                                url: url,
                                parentProduct: parentProduct,
                                cloudId: cloudId,
                                panelData: panelData
                            },
                            entryPoints: {},
                            extraProps: {},
                            queries: {}
                        }),
                    product: "confluencePreviewPanel"
                },
                onOpen: onOpen
            });
        };
        $[0] = cloudId;
        $[1] = open;
        $[2] = parentProduct;
        $[3] = t0;
    } else t0 = $[3];
    const openConfluencePagePreviewPanel = t0;
    let t1;
    if ($[4] !== close || $[5] !== onClose) {
        t1 = ()=>{
            close(onClose);
        };
        $[4] = close;
        $[5] = onClose;
        $[6] = t1;
    } else t1 = $[6];
    const closeConfluencePagePreviewPanel = t1;
    let t2;
    if ($[7] !== closeConfluencePagePreviewPanel || $[8] !== openConfluencePagePreviewPanel) {
        t2 = {
            openConfluencePagePreviewPanel: openConfluencePagePreviewPanel,
            closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel
        };
        $[7] = closeConfluencePagePreviewPanel;
        $[8] = openConfluencePagePreviewPanel;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : (parentProduct, cloudId, onClose)=>{
    const { open: open, close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const openConfluencePagePreviewPanel = (0, $cozmU.useCallback)((url, onOpen, panelData)=>{
        open({
            panel: {
                id: `confluence-page-preview-panel_${url.split('/').pop()}`,
                type: 'confluence-page',
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2w19Y.default), {
                        props: {
                            url: url,
                            parentProduct: parentProduct,
                            cloudId: cloudId,
                            panelData: panelData
                        },
                        entryPoints: {},
                        extraProps: {},
                        queries: {}
                    }),
                product: 'confluencePreviewPanel'
            },
            onOpen: onOpen
        });
    }, [
        open,
        parentProduct,
        cloudId
    ]);
    const closeConfluencePagePreviewPanel = (0, $cozmU.useCallback)(()=>{
        close(onClose);
    }, [
        close,
        onClose
    ]);
    return {
        openConfluencePagePreviewPanel: openConfluencePagePreviewPanel,
        closeConfluencePagePreviewPanel: closeConfluencePagePreviewPanel
    };
};
module.exports["useConfluencePagePreviewPanel"] = $2e15ea96b280ebaf$export$46eb6ca3d43ca839;

});

parcelRegister("2w19Y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");











var $iMnC5 = parcelRequire("iMnC5");


var $eRn3r = parcelRequire("eRn3r");


var $bVevd = parcelRequire("bVevd");


var $cuq2s = parcelRequire("cuq2s");


var $lWz4S = parcelRequire("lWz4S");


var $3cycN = parcelRequire("3cycN");

const $33b978cbeca20c43$var$styles = {
    fallback: "_39xV02N91d _0jFU0VN91d"
};

const $33b978cbeca20c43$var$LazyEmbeddedConfluence = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("9PBzG")));
const $33b978cbeca20c43$export$c4789cfd0b0cd2c4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const t0 = props.mode === (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? "editPage" : "viewPage";
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $33b978cbeca20c43$var$styles.fallback
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRn3r.LazySuspense), {
            fallback: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b978cbeca20c43$var$LazyEmbeddedConfluence, props));
        $[1] = props;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== t0 || $[4] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWz4S.PerformanceMetricsProvider), {
            contentType: t0,
            sourceComponent: "EmbeddedConfluence"
        }, t2);
        $[3] = t0;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== props.locale || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $3cycN.default)
        }, t3);
        $[6] = props.locale;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $3cycN.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWz4S.PerformanceMetricsProvider), {
        contentType: props.mode === (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? 'editPage' : 'viewPage',
        sourceComponent: 'EmbeddedConfluence'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRn3r.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $33b978cbeca20c43$var$styles.fallback
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33b978cbeca20c43$var$LazyEmbeddedConfluence, props))));



var $5WTxQ = parcelRequire("5WTxQ");













var $1l0kj = parcelRequire("1l0kj");


var $7ZxlY = parcelRequire("7ZxlY");

const $d975db42cbae76b2$export$b3bbf50939c515ce = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, testId: testId } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== children || $[1] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), {
                testId: testId
            }, children);
            $[0] = children;
            $[1] = testId;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== children || $[4] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            testId: testId,
            space: "space.050",
            alignBlock: "center"
        }, children);
        $[3] = children;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, testId: testId })=>{
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), {
        testId: testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        testId: testId,
        space: "space.050",
        alignBlock: "center"
    }, children);
};


var $kMhHg = parcelRequire("kMhHg");













var $8VfSP = parcelRequire("8VfSP");





var $8aG6j = parcelRequire("8aG6j");







parcelRequire("cozmU");





var $7ZpVx = parcelRequire("7ZpVx");

const $9d247bad4b88cafd$export$92b065b8b3b3301c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelActionExpand(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { onClick: onClick, testId: testId, label: label } = t0;
    const t1 = label || "Expand panel";
    let t2;
    if ($[0] !== onClick || $[1] !== t1 || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZpVx.PanelAction), {
            onClick: onClick,
            testId: testId,
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
            label: t1
        });
        $[0] = onClick;
        $[1] = t1;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PanelActionExpand({ onClick: onClick, testId: testId, label: label }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZpVx.PanelAction), {
        onClick: onClick,
        testId: testId,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
        label: label || 'Expand panel'
    });
};



var $Emr0i = parcelRequire("Emr0i");


var $6GBgL = parcelRequire("6GBgL");

const $d071f0f047b198a8$export$40b251582cb3e1fe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { onClick: onClick, testId: testId, analyticsContext: analyticsContext } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        if (analyticsContext) {
            let t1;
            if ($[0] !== formatMessage) {
                t1 = formatMessage((0, $Emr0i.default).previewPanelExpandActionLabel);
                $[0] = formatMessage;
                $[1] = t1;
            } else t1 = $[1];
            let t2;
            if ($[2] !== analyticsContext || $[3] !== onClick || $[4] !== t1 || $[5] !== testId) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
                    label: t1,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
                    onClick: onClick,
                    testId: testId,
                    analyticsContext: analyticsContext
                });
                $[2] = analyticsContext;
                $[3] = onClick;
                $[4] = t1;
                $[5] = testId;
                $[6] = t2;
            } else t2 = $[6];
            return t2;
        }
        let t1;
        if ($[7] !== formatMessage) {
            t1 = formatMessage((0, $Emr0i.default).previewPanelExpandActionLabel);
            $[7] = formatMessage;
            $[8] = t1;
        } else t1 = $[8];
        let t2;
        if ($[9] !== onClick || $[10] !== t1 || $[11] !== testId) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d247bad4b88cafd$export$92b065b8b3b3301c), {
                onClick: onClick,
                testId: testId,
                label: t1
            });
            $[9] = onClick;
            $[10] = t1;
            $[11] = testId;
            $[12] = t2;
        } else t2 = $[12];
        return t2;
    }
    let t1;
    if ($[13] !== formatMessage) {
        t1 = formatMessage((0, $Emr0i.default).previewPanelExpandActionLabel);
        $[13] = formatMessage;
        $[14] = t1;
    } else t1 = $[14];
    let t2;
    if ($[15] !== analyticsContext || $[16] !== onClick || $[17] !== t1 || $[18] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
            label: t1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext
        });
        $[15] = analyticsContext;
        $[16] = onClick;
        $[17] = t1;
        $[18] = testId;
        $[19] = t2;
    } else t2 = $[19];
    return t2;
} : ({ onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) {
        if (analyticsContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
            label: formatMessage((0, $Emr0i.default).previewPanelExpandActionLabel),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d247bad4b88cafd$export$92b065b8b3b3301c), {
            onClick: onClick,
            testId: testId,
            label: formatMessage((0, $Emr0i.default).previewPanelExpandActionLabel)
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
        label: formatMessage((0, $Emr0i.default).previewPanelExpandActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext
    });
};


var $fE1YT = parcelRequire("fE1YT");

var $bRCqW = parcelRequire("bRCqW");


var $lRhY3 = parcelRequire("lRhY3");


var $5tX23 = parcelRequire("5tX23");




const $6069647419d4dde0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    blogPostTitle: {
        id: "confluence.page.preview.panel.blogPostTitle",
        defaultMessage: "Confluence Blog Post"
    },
    pageTitle: {
        id: "confluence.page.preview.panel.pageTitle",
        defaultMessage: "Confluence Page"
    },
    whiteboardTitle: {
        id: "confluence.page.preview.panel.whiteboardTitle",
        defaultMessage: "Confluence Whiteboard"
    }
});



var $NF6kd = parcelRequire("NF6kd");


var $l7jo6 = parcelRequire("l7jo6");





var $gyfUL = parcelRequire("gyfUL");

const $e93ddc4012877feb$export$232fd46a0431e57a = (mode, setPanelWidth)=>mode === (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE ? setPanelWidth(Math.floor(window.innerWidth / 2)) : {};
const $e93ddc4012877feb$export$4acedbb0ac692186 = (hostname)=>{
    if (hostname.includes('localhost')) return (0, $l7jo6.envType).LOCAL;
    if (hostname.includes('jira-dev')) return (0, $l7jo6.envType).DEV;
    return (0, $l7jo6.envType).PROD;
};
const $e93ddc4012877feb$export$fbee84a774b6734d = (url, themeParam)=>{
    if (!themeParam) return url;
    if (!url.includes('?')) return `${url}?${themeParam}`;
    const [baseUrl, params] = url.split('?');
    const paramsArr = params.split('&');
    if (paramsArr.includes(themeParam)) return url;
    const otherParams = paramsArr.filter((param)=>!(param.split('=')[0] === 'themeState')).join('&');
    const newParams = otherParams ? `${themeParam}&${otherParams}` : themeParam;
    return `${baseUrl}?${newParams}`;
};
const $e93ddc4012877feb$export$7d842b959fcdcd03 = (cloudId)=>{
    const analyticsClient = new (0, $NF6kd.default)({
        product: 'confluencePreviewPanel',
        env: $e93ddc4012877feb$export$4acedbb0ac692186(window.location?.hostname),
        origin: (0, $l7jo6.originType).WEB
    });
    if (cloudId) analyticsClient.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, cloudId);
    return analyticsClient;
};
const $e93ddc4012877feb$export$d9ce73382ee04318 = (originalUrl, embedUrl)=>{
    if (!embedUrl) return originalUrl;
    try {
        const previewUrl = new URL(embedUrl);
        const contentId = previewUrl.searchParams.get('contentId');
        const spaceKey = previewUrl.searchParams.get('spaceKey');
        const hostname = previewUrl.searchParams.get('hostname');
        if (contentId && spaceKey && hostname) {
            const decodedSpaceKey = decodeURIComponent(spaceKey);
            const resolved = new URL(`https://${hostname}/wiki/spaces/${decodedSpaceKey}/pages/${contentId}`);
            // Preserve all original URL parameters
            const originalUrl_ = new URL(originalUrl);
            for (const [key, value] of originalUrl_.searchParams)resolved.searchParams.set(key, value);
            return resolved.toString();
        }
    } catch  {
        // If URL parsing fails, fall back to original URL
        return originalUrl;
    }
    return originalUrl;
};
const $e93ddc4012877feb$export$a639a54e55b70225 = (themeState, url, panelData)=>{
    const themeStateParam = themeState ? `themeState=${(0, $gyfUL.themeStateObjectToQueryString)(themeState)}` : '';
    const cardStateUrl = panelData ? $e93ddc4012877feb$export$d9ce73382ee04318(url, panelData?.embedUrl) : url;
    const formattedUrl = themeStateParam ? $e93ddc4012877feb$export$fbee84a774b6734d(cardStateUrl, themeStateParam) : cardStateUrl;
    return formattedUrl;
};


const $744066e2d7f4d354$var$styles = {
    body: "_2O5Vij7dHp _2WAcuGnQyn _0Of8r2NHnM _1ZnuxbNHnM _2Zuz6QNHnM"
};
const $744066e2d7f4d354$var$contentTypeTitleMessages = {
    page: (0, $6069647419d4dde0$export$defe85febe8b728c).pageTitle,
    blogpost: (0, $6069647419d4dde0$export$defe85febe8b728c).blogPostTitle,
    whiteboard: (0, $6069647419d4dde0$export$defe85febe8b728c).whiteboardTitle
};
const $744066e2d7f4d354$export$a8a96573251792b1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(55);
    const { url: url, parentProduct: parentProduct, cloudId: cloudId, contentType: t1, panelData: panelData } = t0;
    const contentType = t1 === undefined ? "page" : t1;
    const { close: close, setPanelWidth: setPanelWidth } = (0, $lRhY3.usePreviewPanelsActions)();
    const { canNavigateBack: canNavigateBack, navigateBack: navigateBack } = (0, $5tX23.usePreviewPanelsNavigation)();
    const [analyticsClient, setAnalyticsClient] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const themeState = (0, $IQ4Dz.useThemeObserver)();
    let t2;
    if ($[0] !== panelData) {
        t2 = panelData || {};
        $[0] = panelData;
        $[1] = t2;
    } else t2 = $[1];
    const { actions: actions } = t2;
    let t3;
    let t4;
    if ($[2] !== cloudId) {
        t3 = ()=>{
            setAnalyticsClient((0, $e93ddc4012877feb$export$7d842b959fcdcd03)(cloudId));
        };
        t4 = [
            cloudId,
            setAnalyticsClient
        ];
        $[2] = cloudId;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[5] !== setPanelWidth) {
        t5 = (mode)=>(0, $e93ddc4012877feb$export$232fd46a0431e57a)(mode, setPanelWidth);
        $[5] = setPanelWidth;
        $[6] = t5;
    } else t5 = $[6];
    const onModeChange = t5;
    let t6;
    if ($[7] !== actions || $[8] !== close) {
        t6 = ()=>{
            actions?.onClose?.();
            close();
        };
        $[7] = actions;
        $[8] = close;
        $[9] = t6;
    } else t6 = $[9];
    const onClose = t6;
    let t7;
    if ($[10] !== panelData || $[11] !== themeState || $[12] !== url) {
        t7 = (0, $e93ddc4012877feb$export$a639a54e55b70225)(themeState, url, panelData);
        $[10] = panelData;
        $[11] = themeState;
        $[12] = url;
        $[13] = t7;
    } else t7 = $[13];
    const formattedUrl = t7;
    let t8;
    try {
        let t9;
        if ($[14] !== formattedUrl) {
            const urlObj = new URL(formattedUrl);
            t9 = urlObj.searchParams.get("embeddedConfluenceSource");
            $[14] = formattedUrl;
            $[15] = t9;
        } else t9 = $[15];
        t8 = t9;
    } catch  {
        t8 = null;
    }
    const embeddedConfluenceSource = t8;
    const t9 = actions?.onPublish;
    const t10 = panelData?.allowedFeatures;
    const t11 = embeddedConfluenceSource || "confluence-page-preview-panel";
    let t12;
    if ($[16] !== formattedUrl || $[17] !== onModeChange || $[18] !== parentProduct || $[19] !== t10 || $[20] !== t11 || $[21] !== t9 || $[22] !== themeState) {
        t12 = {
            url: formattedUrl,
            showFooter: false,
            hasFooterLogo: false,
            onModeChange: onModeChange,
            onPublish: t9,
            allowedFeatures: t10,
            parentProduct: parentProduct,
            embeddedConfluenceSource: t11,
            themeState: themeState
        };
        $[16] = formattedUrl;
        $[17] = onModeChange;
        $[18] = parentProduct;
        $[19] = t10;
        $[20] = t11;
        $[21] = t9;
        $[22] = themeState;
        $[23] = t12;
    } else t12 = $[23];
    const runtimeProps = t12;
    let t13;
    if ($[24] !== canNavigateBack || $[25] !== navigateBack) {
        t13 = canNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") ? navigateBack : undefined;
        $[24] = canNavigateBack;
        $[25] = navigateBack;
        $[26] = t13;
    } else t13 = $[26];
    const t14 = actions?.onOpenInNewTab;
    const t15 = $744066e2d7f4d354$var$contentTypeTitleMessages[contentType];
    let t16;
    if ($[27] !== formatMessage || $[28] !== t15) {
        t16 = formatMessage(t15);
        $[27] = formatMessage;
        $[28] = t15;
        $[29] = t16;
    } else t16 = $[29];
    let t17;
    if ($[30] !== contentType) {
        t17 = contentType === "blogpost" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
            label: "",
            size: "medium"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            label: "",
            size: "medium"
        });
        $[30] = contentType;
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== t16 || $[33] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bRCqW.PreviewPanelTitle), {
            title: t16,
            icon: t17
        });
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
    } else t18 = $[34];
    let t19;
    if ($[35] !== actions) {
        t19 = !!actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d975db42cbae76b2$export$b3bbf50939c515ce), null, actions.onExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d071f0f047b198a8$export$40b251582cb3e1fe), {
            onClick: actions.onExpand
        }));
        $[35] = actions;
        $[36] = t19;
    } else t19 = $[36];
    let t20;
    if ($[37] !== analyticsClient || $[38] !== formattedUrl || $[39] !== onClose || $[40] !== parentProduct || $[41] !== t13 || $[42] !== t14 || $[43] !== t18 || $[44] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fE1YT.PreviewPanelHeader), {
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: "confluence-page",
            onClose: onClose,
            onNavigateBack: t13,
            onOpenInNewTab: t14,
            url: formattedUrl
        }, t18, t19);
        $[37] = analyticsClient;
        $[38] = formattedUrl;
        $[39] = onClose;
        $[40] = parentProduct;
        $[41] = t13;
        $[42] = t14;
        $[43] = t18;
        $[44] = t19;
        $[45] = t20;
    } else t20 = $[45];
    let t21;
    if ($[46] !== runtimeProps) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33b978cbeca20c43$export$c4789cfd0b0cd2c4), runtimeProps);
        $[46] = runtimeProps;
        $[47] = t21;
    } else t21 = $[47];
    let t22;
    if ($[48] !== analyticsClient || $[49] !== parentProduct || $[50] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kMhHg.PreviewPanelBody), {
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: "confluence-page",
            styles: $744066e2d7f4d354$var$styles.body
        }, t21);
        $[48] = analyticsClient;
        $[49] = parentProduct;
        $[50] = t21;
        $[51] = t22;
    } else t22 = $[51];
    let t23;
    if ($[52] !== t20 || $[53] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5WTxQ.PreviewPanel), {
            testId: "confluence-preview-panel"
        }, t20, t22);
        $[52] = t20;
        $[53] = t22;
        $[54] = t23;
    } else t23 = $[54];
    return t23;
} : ({ url: url, parentProduct: parentProduct, cloudId: cloudId, contentType: contentType = 'page', panelData: panelData })=>{
    const { close: close, setPanelWidth: setPanelWidth } = (0, $lRhY3.usePreviewPanelsActions)();
    const { canNavigateBack: canNavigateBack, navigateBack: navigateBack } = (0, $5tX23.usePreviewPanelsNavigation)();
    const [analyticsClient, setAnalyticsClient] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const themeState = (0, $IQ4Dz.useThemeObserver)();
    const { actions: actions } = panelData || {};
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        setAnalyticsClient((0, $e93ddc4012877feb$export$7d842b959fcdcd03)(cloudId));
    }, [
        cloudId,
        setAnalyticsClient
    ]);
    const onModeChange = (mode)=>(0, $e93ddc4012877feb$export$232fd46a0431e57a)(mode, setPanelWidth);
    const onClose = ()=>{
        actions?.onClose?.();
        close();
    };
    const formattedUrl = (0, $cozmU.useMemo)(()=>(0, $e93ddc4012877feb$export$a639a54e55b70225)(themeState, url, panelData), [
        panelData,
        url,
        themeState
    ]);
    const embeddedConfluenceSource = (()=>{
        try {
            const urlObj = new URL(formattedUrl);
            return urlObj.searchParams.get('embeddedConfluenceSource');
        } catch  {
            return null;
        }
    })();
    const runtimeProps = {
        url: formattedUrl,
        showFooter: false,
        hasFooterLogo: false,
        onModeChange: onModeChange,
        onPublish: actions?.onPublish,
        allowedFeatures: panelData?.allowedFeatures,
        parentProduct: parentProduct,
        embeddedConfluenceSource: embeddedConfluenceSource || 'confluence-page-preview-panel',
        themeState: themeState
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5WTxQ.PreviewPanel), {
        testId: "confluence-preview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fE1YT.PreviewPanelHeader), {
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: 'confluence-page',
        onClose: onClose,
        onNavigateBack: canNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') ? navigateBack : undefined,
        onOpenInNewTab: actions?.onOpenInNewTab,
        url: formattedUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bRCqW.PreviewPanelTitle), {
        title: formatMessage($744066e2d7f4d354$var$contentTypeTitleMessages[contentType]),
        icon: contentType === 'blogpost' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
            label: "",
            size: "medium"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            label: "",
            size: "medium"
        })
    }), !!actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d975db42cbae76b2$export$b3bbf50939c515ce), null, actions.onExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d071f0f047b198a8$export$40b251582cb3e1fe), {
        onClick: actions.onExpand
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kMhHg.PreviewPanelBody), {
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: 'confluence-page',
        styles: $744066e2d7f4d354$var$styles.body
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33b978cbeca20c43$export$c4789cfd0b0cd2c4), runtimeProps)));
};
const $744066e2d7f4d354$var$ConfluencePagePreviewPanelEntryPointComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { props: t1 } = t0;
    const { url: url, parentProduct: parentProduct, cloudId: cloudId, contentType: contentType, panelData: panelData } = t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== contentType || $[2] !== panelData || $[3] !== parentProduct || $[4] !== url) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($744066e2d7f4d354$export$a8a96573251792b1, {
            url: url,
            parentProduct: parentProduct,
            cloudId: cloudId,
            contentType: contentType,
            panelData: panelData
        });
        $[0] = cloudId;
        $[1] = contentType;
        $[2] = panelData;
        $[3] = parentProduct;
        $[4] = url;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ props: { url: url, parentProduct: parentProduct, cloudId: cloudId, contentType: contentType, panelData: panelData } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($744066e2d7f4d354$export$a8a96573251792b1, {
        url: url,
        parentProduct: parentProduct,
        cloudId: cloudId,
        contentType: contentType,
        panelData: panelData
    });
var $744066e2d7f4d354$export$2e2bcd8739ae039 = $744066e2d7f4d354$var$ConfluencePagePreviewPanelEntryPointComponent;
module.exports["ConfluencePagePreviewPanel"] = $744066e2d7f4d354$export$a8a96573251792b1;
module.exports["default"] = $744066e2d7f4d354$export$2e2bcd8739ae039;

});

parcelRegister("9PBzG", function(module, exports) {

let $728605ffa2c24232$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $728605ffa2c24232$var$load("4u3vY"),
    $728605ffa2c24232$var$load("8hApM"),
    $728605ffa2c24232$var$load("7zI7W"),
    $728605ffa2c24232$var$load("hhss7"),
    $728605ffa2c24232$var$load("iMqwa")
]).then(()=>parcelRequire('l1tsa'));

});

parcelRegister("5tX23", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $28WJb = parcelRequire("28WJb");


var $lRhY3 = parcelRequire("lRhY3");

const $538e9244bcab7b62$var$noop = ()=>{};
const $538e9244bcab7b62$var$PreviewPanelsNavigationContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    history: [],
    canNavigateBack: false,
    clearHistory: $538e9244bcab7b62$var$noop,
    onPanelOpen: $538e9244bcab7b62$var$noop,
    navigateBack: $538e9244bcab7b62$var$noop
});
const $538e9244bcab7b62$export$b66db24661d592b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { children: children, setHistory: setHistory } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [panelHistory, setPanelHistory] = (0, $cozmU.useState)(t1);
    const navigateBackFromPanelRef = (0, $cozmU.useRef)(null);
    const currentPanel = (0, $28WJb.useCurrentPreviewPanel)();
    const { open: openPreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    let t2;
    if ($[1] !== panelHistory || $[2] !== setHistory) {
        t2 = (panel)=>{
            const updatedPanelHistory = [
                ...panelHistory,
                panel
            ];
            setPanelHistory(updatedPanelHistory);
            setHistory?.(updatedPanelHistory);
        };
        $[1] = panelHistory;
        $[2] = setHistory;
        $[3] = t2;
    } else t2 = $[3];
    const addHistoryItem = t2;
    let t3;
    if ($[4] !== panelHistory || $[5] !== setHistory) {
        t3 = ()=>{
            const previousItem = panelHistory.at(-1);
            if (previousItem == null) return null;
            const updatedPanelHistory_0 = panelHistory.slice(0, -1);
            setPanelHistory(updatedPanelHistory_0);
            setHistory?.(updatedPanelHistory_0);
            return previousItem;
        };
        $[4] = panelHistory;
        $[5] = setHistory;
        $[6] = t3;
    } else t3 = $[6];
    const removeLastHistoryItem = t3;
    let t4;
    if ($[7] !== setHistory) {
        t4 = ()=>{
            setPanelHistory([]);
            setHistory?.([]);
        };
        $[7] = setHistory;
        $[8] = t4;
    } else t4 = $[8];
    const clearHistory = t4;
    let t5;
    if ($[9] !== addHistoryItem || $[10] !== currentPanel) {
        t5 = ()=>{
            if (currentPanel != null && navigateBackFromPanelRef.current?.id !== currentPanel.id) addHistoryItem(currentPanel);
            navigateBackFromPanelRef.current = null;
        };
        $[9] = addHistoryItem;
        $[10] = currentPanel;
        $[11] = t5;
    } else t5 = $[11];
    const onPanelOpen = t5;
    let t6;
    if ($[12] !== currentPanel || $[13] !== openPreviewPanel || $[14] !== removeLastHistoryItem) {
        t6 = ()=>{
            if (currentPanel == null) return;
            const panelToOpen = removeLastHistoryItem();
            if (panelToOpen == null) return;
            navigateBackFromPanelRef.current = currentPanel;
            const open = ()=>openPreviewPanel({
                    panel: panelToOpen
                });
            if (panelToOpen.onNavigateBack != null) panelToOpen.onNavigateBack(currentPanel, open);
            else open();
        };
        $[12] = currentPanel;
        $[13] = openPreviewPanel;
        $[14] = removeLastHistoryItem;
        $[15] = t6;
    } else t6 = $[15];
    const navigateBack = t6;
    const canNavigateBack = panelHistory.length > 0;
    let t7;
    let t8;
    if ($[16] !== canNavigateBack || $[17] !== clearHistory || $[18] !== currentPanel) {
        t7 = ()=>{
            if (canNavigateBack && currentPanel == null) {
                clearHistory();
                navigateBackFromPanelRef.current = null;
            }
        };
        t8 = [
            canNavigateBack,
            currentPanel,
            clearHistory
        ];
        $[16] = canNavigateBack;
        $[17] = clearHistory;
        $[18] = currentPanel;
        $[19] = t7;
        $[20] = t8;
    } else {
        t7 = $[19];
        t8 = $[20];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[21] !== canNavigateBack || $[22] !== clearHistory || $[23] !== navigateBack || $[24] !== onPanelOpen || $[25] !== panelHistory) {
        t9 = {
            history: panelHistory,
            canNavigateBack: canNavigateBack,
            clearHistory: clearHistory,
            onPanelOpen: onPanelOpen,
            navigateBack: navigateBack
        };
        $[21] = canNavigateBack;
        $[22] = clearHistory;
        $[23] = navigateBack;
        $[24] = onPanelOpen;
        $[25] = panelHistory;
        $[26] = t9;
    } else t9 = $[26];
    const context = t9;
    let t10;
    if ($[27] !== children || $[28] !== context) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($538e9244bcab7b62$var$PreviewPanelsNavigationContext.Provider, {
            value: context
        }, children);
        $[27] = children;
        $[28] = context;
        $[29] = t10;
    } else t10 = $[29];
    return t10;
} : ({ children: children, setHistory: setHistory })=>{
    const [panelHistory, setPanelHistory] = (0, $cozmU.useState)([]);
    /**
   * Tracks the panel we're navigating away from during `navigateBack` so the next `onPanelOpen` triggered by re-opening the popped panel can be ignored.
   * A ref is required because `onPanelOpen` can be called synchronously within the same tick (`PreviewPanelsProvider` calls the `onOpen` callback before committing/re-rendering).
   */ const navigateBackFromPanelRef = (0, $cozmU.useRef)(null);
    const currentPanel = (0, $28WJb.useCurrentPreviewPanel)();
    const { open: openPreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const addHistoryItem = (0, $cozmU.useCallback)((panel)=>{
        const updatedPanelHistory = [
            ...panelHistory,
            panel
        ];
        setPanelHistory(updatedPanelHistory);
        setHistory?.(updatedPanelHistory);
    }, [
        panelHistory,
        setHistory
    ]);
    const removeLastHistoryItem = (0, $cozmU.useCallback)(()=>{
        const previousItem = panelHistory.at(-1);
        if (previousItem == null) return null;
        const updatedPanelHistory_0 = panelHistory.slice(0, -1);
        setPanelHistory(updatedPanelHistory_0);
        setHistory?.(updatedPanelHistory_0);
        return previousItem;
    }, [
        panelHistory,
        setHistory
    ]);
    const clearHistory = (0, $cozmU.useCallback)(()=>{
        setPanelHistory([]);
        setHistory?.([]);
    }, [
        setHistory
    ]);
    const onPanelOpen = (0, $cozmU.useCallback)(()=>{
        if (currentPanel != null && navigateBackFromPanelRef.current?.id !== currentPanel.id) addHistoryItem(currentPanel);
        navigateBackFromPanelRef.current = null;
    }, [
        currentPanel,
        addHistoryItem
    ]);
    const navigateBack = (0, $cozmU.useCallback)(()=>{
        if (currentPanel == null) return;
        const panelToOpen = removeLastHistoryItem();
        if (panelToOpen == null) return;
        navigateBackFromPanelRef.current = currentPanel;
        const open = ()=>openPreviewPanel({
                panel: panelToOpen
            });
        if (panelToOpen.onNavigateBack != null) panelToOpen.onNavigateBack(currentPanel, open);
        else open();
    }, [
        currentPanel,
        openPreviewPanel,
        removeLastHistoryItem
    ]);
    const canNavigateBack = panelHistory.length > 0;
    (0, $cozmU.useEffect)(()=>{
        // Ensure history is empty when preview panel is closed
        if (canNavigateBack && currentPanel == null) {
            clearHistory();
            navigateBackFromPanelRef.current = null;
        }
    }, [
        canNavigateBack,
        currentPanel,
        clearHistory
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            history: panelHistory,
            canNavigateBack: canNavigateBack,
            clearHistory: clearHistory,
            onPanelOpen: onPanelOpen,
            navigateBack: navigateBack
        }), [
        canNavigateBack,
        panelHistory,
        clearHistory,
        onPanelOpen,
        navigateBack
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($538e9244bcab7b62$var$PreviewPanelsNavigationContext.Provider, {
        value: context
    }, children);
};
const $538e9244bcab7b62$export$fdc48f5600cae5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($538e9244bcab7b62$var$PreviewPanelsNavigationContext);
} : ()=>(0, $cozmU.useContext)($538e9244bcab7b62$var$PreviewPanelsNavigationContext);
module.exports["usePreviewPanelsNavigation"] = $538e9244bcab7b62$export$fdc48f5600cae5d;

});

parcelRegister("6AkEJ", function(module, exports) {

var $kTGj5 = parcelRequire("kTGj5");

const $ae94dfbae65aaefc$export$e1144f7c498cb0b0 = (siteId)=>{
    if (!siteId) return null;
    try {
        return (0, $kTGj5.PlatformSiteAri).create({
            siteId: siteId
        }).toString();
    } catch  {
        return null;
    }
};
module.exports["createPlatformSiteAri"] = $ae94dfbae65aaefc$export$e1144f7c498cb0b0;

});

parcelRegister("5mzE3", function(module, exports) {
/**
 * @generated SignedSource<<0b43df62aea54e17a3770a7a12059f61>>
 * @relayHash a7102f89f3ab6728d9e09db2d61cdef4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a554994f766cbfd751e06f2e26d3665d48b5fcb6e9db32a2aaa8705752e5df8
const $c9ad85efbb5e989e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ari"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "capabilitiesContainerId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryContext"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "goalId",
            "variableName": "ari"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "key"
    }, v8 = {
        "kind": "ScalarField",
        "name": "url"
    }, v9 = {
        "kind": "Variable",
        "name": "queryContext",
        "variableName": "queryContext"
    }, v10 = [
        v9 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "canCreateGoal"
    }, v13 = {
        "kind": "ScalarField",
        "name": "canEditMetrics"
    }, v14 = {
        "kind": "ScalarField",
        "name": "canManagePeriodicMetricTargets"
    }, v15 = {
        "kind": "ScalarField",
        "name": "canRemoveLinkedGoals"
    }, v16 = {
        "kind": "ScalarField",
        "name": "canCreateUpdates"
    }, v17 = {
        "kind": "ScalarField",
        "name": "canAddLinkedProjects"
    }, v18 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v19 = [
        v7 /*: any*/ ,
        v3 /*: any*/ 
    ], v20 = [
        v3 /*: any*/ 
    ], v21 = {
        "kind": "InlineFragment",
        "selections": v20 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v22 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v23 = {
        "concreteType": "TownsquareGoalIcon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "appearance"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "value"
    }, v25 = [
        v24 /*: any*/ 
    ], v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "messageId"
            },
            {
                "kind": "ScalarField",
                "name": "defaultValue"
            }
        ],
        "type": "TownsquareLocalizationField"
    }, v27 = {
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v25 /*: any*/ ,
                "type": "TownsquareGoalTypeCustomName"
            },
            v26 /*: any*/ 
        ]
    }, v28 = {
        "concreteType": "TownsquareGoalTypeIcon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "kind"
    }, v30 = {
        "kind": "LinkedField",
        "name": "namePlural",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v25 /*: any*/ ,
                "type": "TownsquareGoalTypeCustomNamePlural"
            },
            v26 /*: any*/ 
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "score"
    }, v32 = [
        v24 /*: any*/ ,
        v31 /*: any*/ 
    ], v33 = {
        "kind": "ScalarField",
        "name": "scoringMode"
    }, v34 = {
        "kind": "ScalarField",
        "name": "isArchived"
    }, v35 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v36 = {
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            v5 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "accessLevel"
    }, v38 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v39 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v40 = {
        "kind": "ScalarField",
        "name": "end"
    }, v41 = {
        "kind": "ScalarField",
        "name": "start"
    }, v42 = {
        "kind": "ScalarField",
        "name": "confidence"
    }, v43 = {
        "concreteType": "TownsquareTargetDateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v40 /*: any*/ 
        ]
    }, v44 = {
        "concreteType": "TownsquareTargetDate",
        "kind": "LinkedField",
        "name": "date",
        "plural": false,
        "selections": [
            v42 /*: any*/ ,
            v43 /*: any*/ 
        ]
    }, v45 = [
        v24 /*: any*/ ,
        v3 /*: any*/ 
    ], v46 = {
        "kind": "ScalarField",
        "name": "variance"
    }, v47 = {
        "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
        "kind": "LinkedField",
        "name": "latestValue",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricValue",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v45 /*: any*/ 
            },
            v46 /*: any*/ 
        ]
    }, v48 = {
        "kind": "ScalarField",
        "name": "type"
    }, v49 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v50 = {
        "kind": "ScalarField",
        "name": "archived"
    }, v51 = {
        "kind": "ScalarField",
        "name": "externalEntityId"
    }, v52 = {
        "kind": "ScalarField",
        "name": "source"
    }, v53 = {
        "kind": "ScalarField",
        "name": "time"
    }, v54 = [
        v53 /*: any*/ ,
        v3 /*: any*/ ,
        v24 /*: any*/ 
    ], v55 = {
        "kind": "Literal",
        "name": "first",
        "value": 100
    }, v56 = [
        v55 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "sort",
            "value": [
                "TIME_ASC"
            ]
        }
    ], v57 = [
        v11 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v58 = {
        "concreteType": "TownsquareGoalState",
        "kind": "LinkedField",
        "name": "newState",
        "plural": false,
        "selections": v32 /*: any*/ 
    }, v59 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v60 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v61 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v62 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v60 /*: any*/ ,
            v61 /*: any*/ 
        ]
    }, v63 = {
        "args": v56 /*: any*/ ,
        "concreteType": "TownsquareMetricValueConnection",
        "kind": "LinkedField",
        "name": "values",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricValueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "canDelete"
                            },
                            v24 /*: any*/ ,
                            v53 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": v57 /*: any*/ 
                            },
                            {
                                "kind": "LinkedField",
                                "name": "origin",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareGoalUpdate",
                                                "kind": "LinkedField",
                                                "name": "goalUpdate",
                                                "plural": false,
                                                "selections": [
                                                    v39 /*: any*/ ,
                                                    {
                                                        "concreteType": "TownsquareGoal",
                                                        "kind": "LinkedField",
                                                        "name": "goal",
                                                        "plural": false,
                                                        "selections": v20 /*: any*/ 
                                                    },
                                                    v58 /*: any*/ ,
                                                    v3 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "TownsquareFromGoalUpdate"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v39 /*: any*/ 
                                        ],
                                        "type": "TownsquareFromMetricCreation"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "updateDate"
                                            }
                                        ],
                                        "type": "TownsquareFromMetricUpdate"
                                    }
                                ]
                            },
                            v22 /*: any*/ ,
                            v11 /*: any*/ 
                        ]
                    },
                    v59 /*: any*/ 
                ]
            },
            v62 /*: any*/ ,
            v22 /*: any*/ 
        ],
        "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
    }, v64 = {
        "args": v56 /*: any*/ ,
        "filters": [
            "sort"
        ],
        "handle": "connection",
        "key": "SuccessMeasureChart_values",
        "kind": "LinkedHandle",
        "name": "values"
    }, v65 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "snapshotValue",
        "plural": false,
        "selections": v45 /*: any*/ 
    }, v66 = {
        "kind": "ScalarField",
        "name": "startValue"
    }, v67 = {
        "kind": "ScalarField",
        "name": "targetValue"
    }, v68 = [
        v53 /*: any*/ ,
        v3 /*: any*/ 
    ], v69 = {
        "args": v56 /*: any*/ ,
        "concreteType": "TownsquareMetricTargetToMetricValueConnection",
        "kind": "LinkedField",
        "name": "metricValues",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricTargetToMetricValueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": v68 /*: any*/ 
                    },
                    {
                        "concreteType": "TownsquareMetricTargetPeriod",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriod",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "TownsquareTargetDate",
                                "kind": "LinkedField",
                                "name": "date",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareTargetDateRange",
                                        "kind": "LinkedField",
                                        "name": "dateRange",
                                        "plural": false,
                                        "selections": [
                                            v40 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v24 /*: any*/ 
                        ]
                    },
                    v46 /*: any*/ 
                ]
            }
        ],
        "storageKey": "metricValues(first:100,sort:[\"TIME_ASC\"])"
    }, v70 = {
        "kind": "ScalarField",
        "name": "percentage"
    }, v71 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
            v70 /*: any*/ ,
            v48 /*: any*/ 
        ]
    }, v72 = {
        "concreteType": "TownsquareGoalType",
        "kind": "LinkedField",
        "name": "goalType",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v3 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v73 = {
        "concreteType": "TownsquareMetricValue",
        "kind": "LinkedField",
        "name": "latestValue",
        "plural": false,
        "selections": v68 /*: any*/ 
    }, v74 = {
        "concreteType": "TownsquareMetricTargetConnection",
        "kind": "LinkedField",
        "name": "metricTargets",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareMetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "concreteType": "TownsquareMetric",
                                "kind": "LinkedField",
                                "name": "metric",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v48 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    v50 /*: any*/ ,
                                    v51 /*: any*/ ,
                                    v52 /*: any*/ ,
                                    v73 /*: any*/ 
                                ]
                            },
                            v65 /*: any*/ ,
                            v66 /*: any*/ ,
                            v67 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v75 = {
        "concreteType": "TownsquareStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v32 /*: any*/ 
    }, v76 = [
        v43 /*: any*/ 
    ], v77 = {
        "concreteType": "TownsquareTargetDate",
        "kind": "LinkedField",
        "name": "targetDate",
        "plural": false,
        "selections": v76 /*: any*/ 
    }, v78 = {
        "kind": "ScalarField",
        "name": "missedUpdate"
    }, v79 = {
        "kind": "ScalarField",
        "name": "updateType"
    }, v80 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v81 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v82 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ],
        "concreteType": "TownsquareGoalUpdateConnection",
        "kind": "LinkedField",
        "name": "updates",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareGoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v78 /*: any*/ ,
                            v79 /*: any*/ ,
                            v80 /*: any*/ ,
                            v81 /*: any*/ ,
                            v39 /*: any*/ ,
                            v3 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "updates(first:1)"
    }, v83 = {
        "kind": "Literal",
        "name": "first",
        "value": 200
    }, v84 = [
        v83 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "tql",
            "value": "archived = false"
        }
    ], v85 = {
        "concreteType": "TownsquareIconURIs",
        "kind": "LinkedField",
        "name": "iconUrl",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "dark"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "light"
                    }
                ]
            }
        ]
    }, v86 = {
        "concreteType": "TownsquareProjectState",
        "kind": "LinkedField",
        "name": "state",
        "plural": false,
        "selections": v25 /*: any*/ 
    }, v87 = {
        "concreteType": "TownsquareTargetDate",
        "kind": "LinkedField",
        "name": "dueDate",
        "plural": false,
        "selections": v76 /*: any*/ 
    }, v88 = [
        v11 /*: any*/ ,
        v3 /*: any*/ 
    ], v89 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": v88 /*: any*/ 
        }
    ], v90 = {
        "concreteType": "TownsquareContributorConnection",
        "kind": "LinkedField",
        "name": "contributors",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareContributorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareContributor",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "userContributor",
                                "plural": false,
                                "selections": v88 /*: any*/ 
                            },
                            {
                                "concreteType": "TownsquareTeamContributor",
                                "kind": "LinkedField",
                                "name": "teamContributor",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareUserConnection",
                                        "kind": "LinkedField",
                                        "name": "contributingMembers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareUserEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v89 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v91 = {
        "args": v84 /*: any*/ ,
        "filters": [
            "tql"
        ],
        "handle": "connection",
        "key": "GoalContentProjects_projects",
        "kind": "LinkedHandle",
        "name": "projects"
    }, v92 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v93 = [
        v48 /*: any*/ ,
        v70 /*: any*/ 
    ], v94 = {
        "concreteType": "TownsquareGoalProgress",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": v93 /*: any*/ 
    }, v95 = {
        "concreteType": "TownsquareGoalAppCapabilities",
        "kind": "LinkedField",
        "name": "apps",
        "plural": false,
        "selections": [
            v14 /*: any*/ 
        ]
    }, v96 = {
        "kind": "ScalarField",
        "name": "description"
    }, v97 = [
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v96 /*: any*/ 
    ], v98 = [
        v55 /*: any*/ 
    ], v99 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }
    ], v100 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isTownsquareHighlight"
    }, v101 = [
        v11 /*: any*/ ,
        v5 /*: any*/ ,
        v4 /*: any*/ ,
        v35 /*: any*/ ,
        v3 /*: any*/ 
    ], v102 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v101 /*: any*/ 
    }, v103 = {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": v101 /*: any*/ 
    }, v104 = {
        "kind": "ScalarField",
        "name": "lastEditedDate"
    }, v105 = [
        v24 /*: any*/ ,
        v53 /*: any*/ ,
        v3 /*: any*/ 
    ], v106 = [
        v11 /*: any*/ ,
        v35 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v107 = {
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": v106 /*: any*/ 
    }, v108 = {
        "kind": "ScalarField",
        "name": "label"
    }, v109 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v106 /*: any*/ 
    }, v110 = [
        v39 /*: any*/ ,
        {
            "concreteType": "TownsquareGoalState",
            "kind": "LinkedField",
            "name": "newState",
            "plural": false,
            "selections": [
                v24 /*: any*/ ,
                v31 /*: any*/ ,
                v108 /*: any*/ 
            ]
        },
        v80 /*: any*/ ,
        v109 /*: any*/ ,
        {
            "concreteType": "TownsquareUpdateNoteConnection",
            "kind": "LinkedField",
            "name": "updateNotes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareUpdateNoteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "TownsquareUpdateNote",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v80 /*: any*/ ,
                                v96 /*: any*/ ,
                                v50 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v3 /*: any*/ ,
                                v80 /*: any*/ ,
                                v96 /*: any*/ ,
                                v100 /*: any*/ ,
                                v102 /*: any*/ ,
                                v103 /*: any*/ ,
                                v39 /*: any*/ ,
                                v104 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ]
        },
        v3 /*: any*/ 
    ], v111 = {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "latestUserUpdate",
        "plural": false,
        "selections": v110 /*: any*/ 
    }, v112 = [
        v108 /*: any*/ ,
        v43 /*: any*/ 
    ], v113 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v11 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    v35 /*: any*/ ,
                                    v5 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v81 /*: any*/ ,
                            v39 /*: any*/ 
                        ]
                    }
                ]
            },
            v22 /*: any*/ 
        ]
    }, v114 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v80 /*: any*/ ,
                v96 /*: any*/ ,
                v102 /*: any*/ ,
                v103 /*: any*/ ,
                v39 /*: any*/ ,
                v104 /*: any*/ 
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ], v115 = [
        v83 /*: any*/ ,
        v9 /*: any*/ 
    ], v116 = [
        {
            "concreteType": "TownsquareHighlightEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": v89 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "CatchField",
                    "field": {
                        "args": v6 /*: any*/ ,
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goals_byId",
                        "plural": false,
                        "selections": [
                            v3 /*: any*/ ,
                            v7 /*: any*/ ,
                            v8 /*: any*/ ,
                            {
                                "args": v10 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "GoalFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalPanelTitleField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalType"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalMetrics"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ParentGoal"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "SubGoals"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalActions"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalTeams"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalCustomFields"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "GoalUpdateComposerCreate"
                            }
                        ]
                    },
                    "to": "RESULT"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "ari"
                        },
                        {
                            "kind": "Variable",
                            "name": "capabilitiesContainerId",
                            "variableName": "capabilitiesContainerId"
                        },
                        v9 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "GoalPanelTabs"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GoalPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "goals_byId",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedFocusAreas"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedFocusAreas"
                                },
                                {
                                    "concreteType": "TownsquareGoalAppCapabilities",
                                    "kind": "LinkedField",
                                    "name": "apps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareFocusAppCapabilities",
                                            "kind": "LinkedField",
                                            "name": "focus",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewFocusAreas"
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditMetadata"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageOwnership"
                                },
                                v13 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalAppCapabilities",
                                    "kind": "LinkedField",
                                    "name": "apps",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditTargetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedGoals"
                                },
                                v15 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddWatchers"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStartDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canArchiveGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTeams"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTeams"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditCustomFields"
                                },
                                v16 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canWatchGoal"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedProjects"
                                },
                                v17 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedWorkItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedWorkItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddJiraAlignItems"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveJiraAlignItems"
                                }
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "userPermissions"
                                                        },
                                                        v4 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v19 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v19 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v21 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        v23 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v3 /*: any*/ ,
                                v28 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "state"
                                        },
                                        v3 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                v31 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareCompletionGoalState",
                                    "kind": "LinkedField",
                                    "name": "atCompletionState",
                                    "plural": false,
                                    "selections": v32 /*: any*/ 
                                }
                            ]
                        },
                        v33 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                        },
                        v34 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        v38 /*: any*/ ,
                        v39 /*: any*/ ,
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTargetDateRange",
                                    "kind": "LinkedField",
                                    "name": "dateRange",
                                    "plural": false,
                                    "selections": [
                                        v40 /*: any*/ ,
                                        v41 /*: any*/ 
                                    ]
                                },
                                v42 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareMetricTarget",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricTargetPeriods",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v44 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v47 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareMetric",
                                                    "kind": "LinkedField",
                                                    "name": "metric",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v48 /*: any*/ ,
                                                        v49 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        v51 /*: any*/ ,
                                                        v52 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareMetricValue",
                                                            "kind": "LinkedField",
                                                            "name": "latestValue",
                                                            "plural": false,
                                                            "selections": v54 /*: any*/ 
                                                        },
                                                        v22 /*: any*/ ,
                                                        v63 /*: any*/ ,
                                                        v64 /*: any*/ 
                                                    ]
                                                },
                                                v65 /*: any*/ ,
                                                v66 /*: any*/ ,
                                                v67 /*: any*/ ,
                                                v69 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        v71 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v71 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v72 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v74 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v75 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "owner",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v35 /*: any*/ 
                                                    ]
                                                },
                                                v77 /*: any*/ ,
                                                v82 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                {
                                                    "args": v84 /*: any*/ ,
                                                    "concreteType": "TownsquareProjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "projects",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProjectEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v85 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v36 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v90 /*: any*/ 
                                                                    ]
                                                                },
                                                                v59 /*: any*/ ,
                                                                v11 /*: any*/ 
                                                            ]
                                                        },
                                                        v62 /*: any*/ ,
                                                        v22 /*: any*/ 
                                                    ],
                                                    "storageKey": "projects(first:200,tql:\"archived = false\")"
                                                },
                                                v91 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "args": v92 /*: any*/ ,
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v94 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        v27 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v28 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ ,
                                                v75 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "owner",
                                                    "plural": false,
                                                    "selections": v57 /*: any*/ 
                                                },
                                                v77 /*: any*/ ,
                                                v82 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareMetricTargetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricTargets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareMetricTargetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTarget",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v66 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "TownsquareMetricTargetPeriodConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "metricTargetPeriods",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareMetricTargetPeriod",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v44 /*: any*/ ,
                                                                                                v24 /*: any*/ ,
                                                                                                v47 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "TownsquareMetric",
                                                                            "kind": "LinkedField",
                                                                            "name": "metric",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v48 /*: any*/ ,
                                                                                v49 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                v63 /*: any*/ ,
                                                                                v64 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v67 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v69 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalCapabilities",
                                                    "kind": "LinkedField",
                                                    "name": "capabilities",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v95 /*: any*/ 
                                                    ]
                                                },
                                                v37 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "successMeasures(first:50)"
                        },
                        {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                v95 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v3 /*: any*/ ,
                                v71 /*: any*/ ,
                                v74 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": v25 /*: any*/ 
                                },
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "goalType",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                },
                                v37 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareGoalCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v15 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v96 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v61 /*: any*/ ,
                                        v60 /*: any*/ 
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareSlackConnectionConnection",
                            "kind": "LinkedField",
                            "name": "slackChannels",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareSlackConnectionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareSlackConnection",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareSlackChannel",
                                                    "kind": "LinkedField",
                                                    "name": "channel",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "numMembers"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareMsteamsConnectedChannelConnection",
                            "kind": "LinkedField",
                            "name": "msteamsChannels",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareMsteamsConnectedChannelEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareMsteamsConnectedChannelInfo",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v84 /*: any*/ ,
                            "concreteType": "TownsquareProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "args": v92 /*: any*/ ,
                                                    "concreteType": "TownsquareTeamConnection",
                                                    "kind": "LinkedField",
                                                    "name": "teams",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareTeamEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TeamV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": v20 /*: any*/ 
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "teams(first:50)"
                                                },
                                                v11 /*: any*/ ,
                                                v86 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v90 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareProjectUpdate",
                                                    "kind": "LinkedField",
                                                    "name": "latestUserUpdate",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProjectPhaseDetails",
                                                            "kind": "LinkedField",
                                                            "name": "newPhase",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": "_id",
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                },
                                                v34 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v85 /*: any*/ ,
                                                v87 /*: any*/ 
                                            ]
                                        },
                                        v11 /*: any*/ ,
                                        v59 /*: any*/ 
                                    ]
                                },
                                v62 /*: any*/ ,
                                v22 /*: any*/ 
                            ],
                            "storageKey": "projects(first:200,tql:\"archived = false\")"
                        },
                        v91 /*: any*/ ,
                        {
                            "concreteType": "TownsquareGoalTeamConnection",
                            "kind": "LinkedField",
                            "name": "teams",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalTeamEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "canRemove"
                                        },
                                        {
                                            "concreteType": "TeamV2",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "smallAvatarImageUrl"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isVerified"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "profileUrl"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareCustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareCustomFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v97 /*: any*/ ,
                                                                    "type": "TownsquareTextCustomFieldDefinition"
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "alias": "textValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v97 /*: any*/ ,
                                                                    "type": "TownsquareNumberCustomFieldDefinition"
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "alias": "numberValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareNumberCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v97 /*: any*/ ,
                                                                    "type": "TownsquareUserCustomFieldDefinition"
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v98 /*: any*/ ,
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isUser"
                                                                                },
                                                                                v4 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v59 /*: any*/ 
                                                                    ]
                                                                },
                                                                v62 /*: any*/ ,
                                                                v22 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v98 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldUser_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v22 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareUserCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canSetMultipleValues"
                                                                        },
                                                                        {
                                                                            "args": v98 /*: any*/ ,
                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedValues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v3 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "allowedValues(first:100)"
                                                                        }
                                                                    ],
                                                                    "type": "TownsquareTextSelectCustomFieldDefinition"
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v98 /*: any*/ ,
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                {
                                                                                    "alias": "selectValue",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "value"
                                                                                },
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v59 /*: any*/ 
                                                                    ]
                                                                },
                                                                v62 /*: any*/ ,
                                                                v22 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v98 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldTextSelect_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v22 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextSelectCustomField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v99 /*: any*/ ,
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v80 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updateNotes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUpdateNote",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v80 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v50 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v11 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                v78 /*: any*/ ,
                                                v79 /*: any*/ ,
                                                v58 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDateConfidence"
                                                },
                                                {
                                                    "concreteType": "TownsquareHighlightConnection",
                                                    "kind": "LinkedField",
                                                    "name": "highlights",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareHighlightEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v80 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v3 /*: any*/ ,
                                                                        v100 /*: any*/ ,
                                                                        v102 /*: any*/ ,
                                                                        v103 /*: any*/ ,
                                                                        v39 /*: any*/ ,
                                                                        v104 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "metricUpdate",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalMetricUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetric",
                                                                            "kind": "LinkedField",
                                                                            "name": "metric",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v48 /*: any*/ ,
                                                                                v49 /*: any*/ ,
                                                                                v50 /*: any*/ ,
                                                                                v52 /*: any*/ ,
                                                                                v73 /*: any*/ ,
                                                                                {
                                                                                    "args": [
                                                                                        v55 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "sort",
                                                                                            "value": [
                                                                                                "TIME_DESC"
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "TownsquareMetricValueConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareMetricValueEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareMetricValue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": v105 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "TownsquareMetricValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "newValue",
                                                                            "plural": false,
                                                                            "selections": v105 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "TownsquareMetricValue",
                                                                            "kind": "LinkedField",
                                                                            "name": "oldValue",
                                                                            "plural": false,
                                                                            "selections": v54 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "newStartValue"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "newTargetValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareGoal",
                                                    "kind": "LinkedField",
                                                    "name": "goal",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareMetricTargetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "metricTargets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareMetricTargetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareMetricTarget",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareMetric",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "metric",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v3 /*: any*/ ,
                                                                                        v50 /*: any*/ ,
                                                                                        v4 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v49 /*: any*/ ,
                                                                                        v51 /*: any*/ ,
                                                                                        v52 /*: any*/ ,
                                                                                        v73 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "metricTargetPeriods",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "TownsquareTargetDate",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "date",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "TownsquareTargetDateRange",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "dateRange",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v41 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v24 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v3 /*: any*/ ,
                                                                                v66 /*: any*/ ,
                                                                                v67 /*: any*/ ,
                                                                                v65 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v3 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v50 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareGoalType",
                                                            "kind": "LinkedField",
                                                            "name": "goalType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalType",
                                                                    "kind": "LinkedField",
                                                                    "name": "successMeasure",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        },
                                                        v94 /*: any*/ ,
                                                        {
                                                            "args": v92 /*: any*/ ,
                                                            "concreteType": "TownsquareGoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "successMeasures",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v50 /*: any*/ ,
                                                                                v71 /*: any*/ ,
                                                                                v74 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v77 /*: any*/ ,
                                                                                v107 /*: any*/ ,
                                                                                v111 /*: any*/ ,
                                                                                v18 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "TownsquareGoalType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "goalType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v30 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v3 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v75 /*: any*/ ,
                                                                                v82 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "successMeasures(first:50)"
                                                        },
                                                        {
                                                            "concreteType": "TownsquareGoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "subGoals",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v50 /*: any*/ ,
                                                                                v71 /*: any*/ ,
                                                                                v72 /*: any*/ ,
                                                                                v74 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v33 /*: any*/ ,
                                                                                v77 /*: any*/ ,
                                                                                v107 /*: any*/ ,
                                                                                v111 /*: any*/ ,
                                                                                v34 /*: any*/ ,
                                                                                v75 /*: any*/ ,
                                                                                v82 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 10
                                                                }
                                                            ],
                                                            "concreteType": "TownsquareGoalUpdateConnection",
                                                            "kind": "LinkedField",
                                                            "name": "updates",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdateEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoalUpdate",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v80 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "updateNotes",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "TownsquareUpdateNote",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v80 /*: any*/ ,
                                                                                                        v96 /*: any*/ ,
                                                                                                        v3 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "updates(first:10)"
                                                        }
                                                    ]
                                                },
                                                v109 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v112 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalProgress",
                                                    "kind": "LinkedField",
                                                    "name": "newProgress",
                                                    "plural": false,
                                                    "selections": v93 /*: any*/ 
                                                },
                                                {
                                                    "args": v92 /*: any*/ ,
                                                    "concreteType": "TownsquareGoalBundledUpdateConnection",
                                                    "kind": "LinkedField",
                                                    "name": "bundledUpdates",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "successMeasure",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareGoalProgress",
                                                                            "kind": "LinkedField",
                                                                            "name": "progress",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v70 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v3 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareGoalUpdate",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": v110 /*: any*/ 
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "nodeMissingReason"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareGoal",
                                                                    "kind": "LinkedField",
                                                                    "name": "goal",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v94 /*: any*/ ,
                                                                        v74 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v77 /*: any*/ ,
                                                                        v107 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "bundledUpdates(first:50)"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v35 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v3 /*: any*/ 
                                                    ]
                                                },
                                                v81 /*: any*/ ,
                                                {
                                                    "args": v98 /*: any*/ ,
                                                    "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "viewers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v3 /*: any*/ ,
                                                                                v4 /*: any*/ ,
                                                                                v35 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v20 /*: any*/ ,
                                                                            "type": "CustomerUser"
                                                                        }
                                                                    ]
                                                                },
                                                                v3 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "viewers(first:100)"
                                                },
                                                v8 /*: any*/ ,
                                                v113 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareGoalState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v32 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v112 /*: any*/ 
                                                }
                                            ]
                                        },
                                        v59 /*: any*/ 
                                    ]
                                },
                                v62 /*: any*/ ,
                                v22 /*: any*/ 
                            ],
                            "storageKey": "updates(first:20)"
                        },
                        {
                            "args": v99 /*: any*/ ,
                            "handle": "connection",
                            "key": "UpdatesList__updates",
                            "kind": "LinkedHandle",
                            "name": "updates"
                        },
                        {
                            "concreteType": "TownsquareGoalUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                                    "kind": "LinkedField",
                                    "name": "metricUpdate",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareGoalMetricUpdate",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareMetricValue",
                                                            "kind": "LinkedField",
                                                            "name": "newValue",
                                                            "plural": false,
                                                            "selections": v68 /*: any*/ 
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        v96 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "descriptionWhy"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "descriptionMeasurement"
                        },
                        v113 /*: any*/ ,
                        v50 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "updateStreak"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "latestUpdateDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isWatching"
                        },
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v114 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v114 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v114 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "args": v115 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
                            "kind": "LinkedField",
                            "name": "workItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v80 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webUrl"
                                                        }
                                                    ],
                                                    "type": "JiraIssue"
                                                },
                                                v21 /*: any*/ 
                                            ]
                                        },
                                        v59 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ]
                                },
                                v62 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "args": v115 /*: any*/ ,
                            "filters": [
                                "queryContext"
                            ],
                            "handle": "connection",
                            "key": "GoalContentJira_workItems",
                            "kind": "LinkedHandle",
                            "name": "workItems"
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraAlignItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectName"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "mercuryProjectStatus",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mercuryName"
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryTargetDateEnd"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mercuryProjectUrl"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "mercuryProjectOwner",
                                                            "plural": false,
                                                            "selections": v106 /*: any*/ 
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "externalOwner",
                                                            "plural": false,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "firstName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "lastName"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAlignAggProject"
                                                },
                                                v21 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraAlignItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v88 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "alias": "learningsHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "LEARNING"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v116 /*: any*/ ,
                            "storageKey": "highlights(type:\"LEARNING\")"
                        },
                        {
                            "alias": "risksHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "RISK"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v116 /*: any*/ ,
                            "storageKey": "highlights(type:\"RISK\")"
                        },
                        {
                            "alias": "decisionsHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "DECISION"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v116 /*: any*/ ,
                            "storageKey": "highlights(type:\"DECISION\")"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "capabilitiesContainerId"
                        }
                    ],
                    "concreteType": "TownsquareProjectAppCapabilities",
                    "kind": "LinkedField",
                    "name": "projects_capabilities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canCreateProject"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6a554994f766cbfd751e06f2e26d3665d48b5fcb6e9db32a2aaa8705752e5df8",
            "metadata": {},
            "name": "GoalPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c9ad85efbb5e989e$var$node.hash = "a5f51fa89669af750f2ec6dc9462ebb0";
var $c9ad85efbb5e989e$export$2e2bcd8739ae039 = $c9ad85efbb5e989e$var$node;
module.exports["default"] = $c9ad85efbb5e989e$export$2e2bcd8739ae039;

});

parcelRegister("ggAfO", function(module, exports) {

let $bd7a4341c55e9378$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bd7a4341c55e9378$var$load("kT6dz"),
    $bd7a4341c55e9378$var$load("1GcJI"),
    $bd7a4341c55e9378$var$load("bXcw7"),
    $bd7a4341c55e9378$var$load("j2Da2"),
    $bd7a4341c55e9378$var$load("fV5Jo"),
    $bd7a4341c55e9378$var$load("8hP2l"),
    $bd7a4341c55e9378$var$load("1XtfK"),
    $bd7a4341c55e9378$var$load("80Yra"),
    $bd7a4341c55e9378$var$load("2OemJ"),
    $bd7a4341c55e9378$var$load("hUbK8"),
    $bd7a4341c55e9378$var$load("f2rMU"),
    $bd7a4341c55e9378$var$load("g4bFE"),
    $bd7a4341c55e9378$var$load("exl8k"),
    $bd7a4341c55e9378$var$load("2mGc6"),
    $bd7a4341c55e9378$var$load("d19Pa"),
    $bd7a4341c55e9378$var$load("fB5NV"),
    $bd7a4341c55e9378$var$load("ir5Be"),
    $bd7a4341c55e9378$var$load("kccW9"),
    $bd7a4341c55e9378$var$load("iPvQ1"),
    $bd7a4341c55e9378$var$load("30iG7"),
    $bd7a4341c55e9378$var$load("ilUG7"),
    $bd7a4341c55e9378$var$load("efUj2"),
    $bd7a4341c55e9378$var$load("9diYR"),
    $bd7a4341c55e9378$var$load("lqfYE"),
    $bd7a4341c55e9378$var$load("84Qrx"),
    $bd7a4341c55e9378$var$load("7SteV"),
    $bd7a4341c55e9378$var$load("k72sK"),
    $bd7a4341c55e9378$var$load("kD76L"),
    $bd7a4341c55e9378$var$load("8H6bN"),
    $bd7a4341c55e9378$var$load("eUsnQ"),
    $bd7a4341c55e9378$var$load("6C7Vr"),
    $bd7a4341c55e9378$var$load("3vH95"),
    $bd7a4341c55e9378$var$load("fnO1K"),
    $bd7a4341c55e9378$var$load("dZYhM"),
    $bd7a4341c55e9378$var$load("7LDtT"),
    $bd7a4341c55e9378$var$load("1YU2Y"),
    $bd7a4341c55e9378$var$load("4GjU8"),
    $bd7a4341c55e9378$var$load("exK5D"),
    $bd7a4341c55e9378$var$load("1ThhV"),
    $bd7a4341c55e9378$var$load("4KIrO"),
    $bd7a4341c55e9378$var$load("kkkxt"),
    $bd7a4341c55e9378$var$load("1FRba"),
    $bd7a4341c55e9378$var$load("eyDge"),
    $bd7a4341c55e9378$var$load("4x9Jx"),
    $bd7a4341c55e9378$var$load("iWnyc"),
    $bd7a4341c55e9378$var$load("bz5vC"),
    $bd7a4341c55e9378$var$load("ipIDQ"),
    $bd7a4341c55e9378$var$load("ea3NB"),
    $bd7a4341c55e9378$var$load("6wr18"),
    $bd7a4341c55e9378$var$load("59hV4"),
    $bd7a4341c55e9378$var$load("fibpY"),
    $bd7a4341c55e9378$var$load("4O6U4"),
    $bd7a4341c55e9378$var$load("5He1y"),
    $bd7a4341c55e9378$var$load("ffEVr"),
    $bd7a4341c55e9378$var$load("i7f39"),
    $bd7a4341c55e9378$var$load("hwJJ4"),
    $bd7a4341c55e9378$var$load("hhss7"),
    $bd7a4341c55e9378$var$load("Wowvf"),
    $bd7a4341c55e9378$var$load("lkxmG"),
    $bd7a4341c55e9378$var$load("7EorR"),
    $bd7a4341c55e9378$var$load("Lm7SH"),
    $bd7a4341c55e9378$var$load("g6lai")
]).then(()=>parcelRequire('a7bfH'));

});

parcelRegister("jyaqh", function(module, exports) {

let $e3b94715c2bf0057$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e3b94715c2bf0057$var$load("ilUG7"),
    $e3b94715c2bf0057$var$load("efUj2"),
    $e3b94715c2bf0057$var$load("cL90P"),
    $e3b94715c2bf0057$var$load("fob67"),
    $e3b94715c2bf0057$var$load("i7f39"),
    $e3b94715c2bf0057$var$load("hwJJ4"),
    $e3b94715c2bf0057$var$load("j2Da2"),
    $e3b94715c2bf0057$var$load("fV5Jo"),
    $e3b94715c2bf0057$var$load("8hP2l"),
    $e3b94715c2bf0057$var$load("1XtfK"),
    $e3b94715c2bf0057$var$load("Lm7SH"),
    $e3b94715c2bf0057$var$load("6OMo6"),
    $e3b94715c2bf0057$var$load("aaRXj"),
    $e3b94715c2bf0057$var$load("fHlIz"),
    $e3b94715c2bf0057$var$load("4QwAJ"),
    $e3b94715c2bf0057$var$load("3i44s"),
    $e3b94715c2bf0057$var$load("5kI0b"),
    $e3b94715c2bf0057$var$load("kYkz1"),
    $e3b94715c2bf0057$var$load("jfYeU"),
    $e3b94715c2bf0057$var$load("b4nm1"),
    $e3b94715c2bf0057$var$load("geXPZ"),
    $e3b94715c2bf0057$var$load("aQ5uu"),
    $e3b94715c2bf0057$var$load("6wr18"),
    $e3b94715c2bf0057$var$load("jxB64"),
    $e3b94715c2bf0057$var$load("1gATC"),
    $e3b94715c2bf0057$var$load("9KCOJ"),
    $e3b94715c2bf0057$var$load("1xRFJ"),
    $e3b94715c2bf0057$var$load("1kOik"),
    $e3b94715c2bf0057$var$load("eW2qV"),
    $e3b94715c2bf0057$var$load("bxj2D"),
    $e3b94715c2bf0057$var$load("f2rMU"),
    $e3b94715c2bf0057$var$load("kHnae"),
    $e3b94715c2bf0057$var$load("42SV3"),
    $e3b94715c2bf0057$var$load("6xxGo"),
    $e3b94715c2bf0057$var$load("eUsnQ"),
    $e3b94715c2bf0057$var$load("6C7Vr"),
    $e3b94715c2bf0057$var$load("3vH95"),
    $e3b94715c2bf0057$var$load("fnO1K"),
    $e3b94715c2bf0057$var$load("dZYhM"),
    $e3b94715c2bf0057$var$load("aEiTV"),
    $e3b94715c2bf0057$var$load("iY0Ii"),
    $e3b94715c2bf0057$var$load("kkkxt"),
    $e3b94715c2bf0057$var$load("1FRba"),
    $e3b94715c2bf0057$var$load("4x9Jx"),
    $e3b94715c2bf0057$var$load("kHXvF"),
    $e3b94715c2bf0057$var$load("iWnyc"),
    $e3b94715c2bf0057$var$load("bz5vC"),
    $e3b94715c2bf0057$var$load("ea3NB"),
    $e3b94715c2bf0057$var$load("dfnmm"),
    $e3b94715c2bf0057$var$load("gkVge"),
    $e3b94715c2bf0057$var$load("ffEVr"),
    $e3b94715c2bf0057$var$load("hhss7"),
    $e3b94715c2bf0057$var$load("Wowvf"),
    $e3b94715c2bf0057$var$load("lkxmG"),
    $e3b94715c2bf0057$var$load("7EorR"),
    $e3b94715c2bf0057$var$load("kT6dz"),
    $e3b94715c2bf0057$var$load("3eaHI")
]).then(()=>parcelRequire('8wR59'));

});

parcelRegister("9fwsK", function(module, exports) {
/**
 * @generated SignedSource<<03e2d7b61494eecb72dcab813bf70ce5>>
 * @relayHash e09be1aaeecbd37ad19f321a2cf83fcd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe6e28ba0ed4a244d010dbc95d5fd7f23e44c1db00ca6445ad94c2d958ab2de5
const $13f6ba1ca2449bb6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ari"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "capabilitiesContainerId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isProjectNativeIntegrationEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryContext"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "projectId",
            "variableName": "ari"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "url"
    }, v11 = [
        v5 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "canEditMembers"
    }, v13 = {
        "kind": "Variable",
        "name": "queryContext",
        "variableName": "queryContext"
    }, v14 = [
        v13 /*: any*/ 
    ], v15 = [
        {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "capabilitiesContainerId"
        }
    ], v16 = {
        "args": v15 /*: any*/ ,
        "concreteType": "TownsquareGoalAppCapabilities",
        "kind": "LinkedField",
        "name": "goals_capabilities",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canCreateGoal"
            }
        ]
    }, v17 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = [
        v18 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v20 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isUser"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v22 = {
        "kind": "ScalarField",
        "name": "count"
    }, v23 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "canEditMetadata"
    }, v25 = {
        "kind": "ScalarField",
        "name": "canCreateUpdates"
    }, v26 = {
        "kind": "ScalarField",
        "name": "dark"
    }, v27 = {
        "kind": "ScalarField",
        "name": "light"
    }, v28 = {
        "kind": "ScalarField",
        "name": "description"
    }, v29 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v30 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v31 = {
        "kind": "ScalarField",
        "name": "key"
    }, v32 = {
        "kind": "ScalarField",
        "name": "value"
    }, v33 = [
        v32 /*: any*/ 
    ], v34 = {
        "concreteType": "TownsquareTargetDateRange",
        "kind": "LinkedField",
        "name": "dateRange",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "start"
            },
            {
                "kind": "ScalarField",
                "name": "end"
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v36 = [
        {
            "concreteType": "TownsquareLinkEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "TownsquareLink",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v10 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        v23 /*: any*/ 
    ], v37 = {
        "kind": "ScalarField",
        "name": "uuid"
    }, v38 = [
        v31 /*: any*/ ,
        v5 /*: any*/ 
    ], v39 = {
        "kind": "InlineFragment",
        "selections": v11 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v40 = {
        "kind": "ScalarField",
        "name": "creationDate"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": v11 /*: any*/ ,
        "type": "AppUser"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": v11 /*: any*/ ,
        "type": "CustomerUser"
    }, v43 = [
        {
            "concreteType": "TownsquareHighlightEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v18 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "editDate"
    }, v45 = {
        "concreteType": "TownsquareCommentConnection",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
            {
                "concreteType": "TownsquareCommentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "TownsquareComment",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "creator",
                                "plural": false,
                                "selections": [
                                    v18 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v8 /*: any*/ ,
                                    v7 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "commentText"
                            },
                            v44 /*: any*/ ,
                            v40 /*: any*/ 
                        ]
                    }
                ]
            },
            v23 /*: any*/ 
        ]
    }, v46 = [
        {
            "kind": "ScalarField",
            "name": "label"
        },
        v34 /*: any*/ 
    ], v47 = [
        {
            "alias": "projectValue",
            "kind": "ScalarField",
            "name": "value"
        }
    ], v48 = [
        v18 /*: any*/ ,
        v7 /*: any*/ ,
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v5 /*: any*/ 
    ], v49 = {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v48 /*: any*/ 
    }, v50 = {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": v48 /*: any*/ 
    }, v51 = {
        "kind": "ScalarField",
        "name": "lastEditedDate"
    }, v52 = [
        {
            "kind": "InlineFragment",
            "selections": [
                v35 /*: any*/ ,
                v28 /*: any*/ ,
                v49 /*: any*/ ,
                v50 /*: any*/ ,
                v40 /*: any*/ ,
                v51 /*: any*/ 
            ],
            "type": "TownsquareHighlight",
            "abstractKey": "__isTownsquareHighlight"
        }
    ], v53 = [
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v28 /*: any*/ 
    ], v54 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v55 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v56 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v29 /*: any*/ 
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "canRemoveLinkedWorkItems"
    }, v58 = {
        "kind": "ScalarField",
        "name": "canAddLinkedWorkItems"
    }, v59 = {
        "kind": "ScalarField",
        "name": "webUrl"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "CatchField",
                    "field": {
                        "args": v9 /*: any*/ ,
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "projects_byId",
                        "plural": false,
                        "selections": [
                            v5 /*: any*/ ,
                            v10 /*: any*/ ,
                            {
                                "kind": "LinkedField",
                                "name": "owner",
                                "plural": false,
                                "selections": v11 /*: any*/ 
                            },
                            {
                                "concreteType": "TownsquareContributorConnection",
                                "kind": "LinkedField",
                                "name": "contributors",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "TownsquareContributorEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "TownsquareContributor",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "userContributor",
                                                        "plural": false,
                                                        "selections": v11 /*: any*/ 
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            v12 /*: any*/ ,
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v14 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "ProjectJiraWork"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelHeader"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTags"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectTargetDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStatusField"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectOwner"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectLinks"
                            },
                            {
                                "condition": "isProjectNativeIntegrationEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ProjectWorkTracked"
                                    }
                                ]
                            },
                            {
                                "args": v14 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "ProjectFocusAreas"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectStartDate"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "RelatedProjects"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributesTo"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectContributors"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectFollowers"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectActionsContent"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectPanelTabs"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "ProjectCustomFields"
                            }
                        ]
                    },
                    "to": "RESULT"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "capabilitiesContainerId",
                            "variableName": "capabilitiesContainerId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ProjectActionsContent_Capabilities"
                },
                v16 /*: any*/ ,
                {
                    "args": v17 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "ProjectFocusAreas_MercuryWorkspace"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ProjectPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "projects_byId",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": v19 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareContributorConnection",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareContributorEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareContributor",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "userContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTeamContributor",
                                                    "kind": "LinkedField",
                                                    "name": "teamContributor",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "contributingMembers",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v22 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TeamV2",
                                                            "kind": "LinkedField",
                                                            "name": "team",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "smallAvatarImageUrl"
                                                                },
                                                                {
                                                                    "concreteType": "TeamMemberConnectionV2",
                                                                    "kind": "LinkedField",
                                                                    "name": "members",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TeamMemberEdgeV2",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TeamMemberV2",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "member",
                                                                                            "plural": false,
                                                                                            "selections": v19 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "profileUrl"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "permission"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isVerified"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v23 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                v24 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveTags"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditTargetDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageOwnership"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddRelatedLink"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditRelatedLink"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveRelatedLink"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedFocusAreas"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedFocusAreas"
                                },
                                {
                                    "concreteType": "TownsquareProjectAppCapabilities",
                                    "kind": "LinkedField",
                                    "name": "apps",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareFocusAppCapabilities",
                                            "kind": "LinkedField",
                                            "name": "focus",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canViewFocusAreas"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditStartDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddContributors"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveContributors"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddWatchers"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveWatchers"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canManageAccess"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canArchiveProject"
                                },
                                v25 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnProject"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canCommentOnUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canDeleteUpdates"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canEditCustomFields"
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareWorkspace",
                            "kind": "LinkedField",
                            "name": "workspace",
                            "plural": false,
                            "selections": v11 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "roundedSquare",
                                    "plural": false,
                                    "selections": [
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareTagConnection",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareTag",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "usageCount"
                                                },
                                                v28 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v23 /*: any*/ 
                            ]
                        },
                        v31 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isArchived"
                        },
                        {
                            "concreteType": "TownsquareProjectState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": v33 /*: any*/ 
                        },
                        {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "dueDate",
                            "plural": false,
                            "selections": [
                                v34 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "confidence"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "startDate"
                        },
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                v23 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "watcherCount"
                        },
                        {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                                v35 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUpdateNoteConnection",
                                    "kind": "LinkedField",
                                    "name": "updateNotes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "TownsquareUpdateNote",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v35 /*: any*/ ,
                                                        v28 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareLinkConnection",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": v36 /*: any*/ 
                        },
                        {
                            "args": v14 /*: any*/ ,
                            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
                            "kind": "LinkedField",
                            "name": "focusAreas",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v37 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "userPermissions"
                                                        },
                                                        v6 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusAreaStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": v38 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "MercuryFocusAreaHealth",
                                                            "kind": "LinkedField",
                                                            "name": "health",
                                                            "plural": false,
                                                            "selections": v38 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "MercuryFocusArea"
                                                },
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                v23 /*: any*/ 
                            ]
                        },
                        v40 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectDependencyConnection",
                            "kind": "LinkedField",
                            "name": "dependencies",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectDependencyEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectDependency",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "linkType"
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "incomingProject",
                                                    "plural": false,
                                                    "selections": v11 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProject",
                                                    "kind": "LinkedField",
                                                    "name": "outgoingProject",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v31 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "TownsquareIconURIs",
                                                            "kind": "LinkedField",
                                                            "name": "iconUrl",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareThemeURIs",
                                                                    "kind": "LinkedField",
                                                                    "name": "square",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        v26 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v23 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddRelatedProjects"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveRelatedProjects"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canAddLinkedGoals"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "canRemoveLinkedGoals"
                                },
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "goals",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareGoal",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "TownsquareStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": v33 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareGoalType",
                                                    "kind": "LinkedField",
                                                    "name": "goalType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoalTypeIcon",
                                                            "kind": "LinkedField",
                                                            "name": "icon",
                                                            "plural": false,
                                                            "selections": [
                                                                v31 /*: any*/ 
                                                            ]
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v23 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareProjectAccessConnection",
                            "kind": "LinkedField",
                            "name": "access",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectAccessEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "role"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v11 /*: any*/ ,
                                                    "type": "User",
                                                    "abstractKey": "__isUser"
                                                },
                                                v39 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v11 /*: any*/ ,
                                                    "type": "AtlassianAccountUser"
                                                },
                                                v42 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrivate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessLevel"
                        },
                        {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "watchers",
                            "plural": false,
                            "selections": [
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "TownsquareUserEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "learningsHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "LEARNING"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v43 /*: any*/ ,
                            "storageKey": "highlights(type:\"LEARNING\")"
                        },
                        {
                            "alias": "risksHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "RISK"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v43 /*: any*/ ,
                            "storageKey": "highlights(type:\"RISK\")"
                        },
                        {
                            "alias": "decisionsHighlights",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "type",
                                    "value": "DECISION"
                                }
                            ],
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": v43 /*: any*/ ,
                            "storageKey": "highlights(type:\"DECISION\")"
                        },
                        {
                            "concreteType": "TownsquareProjectDescription",
                            "kind": "LinkedField",
                            "name": "description",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "what"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "why"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "measurement"
                                }
                            ]
                        },
                        v45 /*: any*/ ,
                        {
                            "concreteType": "TownsquareProjectUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "TownsquareProjectUpdate",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ari"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "missedUpdate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "updateType"
                                                },
                                                v35 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "creator",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "newDueDate",
                                                    "plural": false,
                                                    "selections": v46 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "newState",
                                                    "plural": false,
                                                    "selections": v47 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lastEditedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                v40 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "viewers",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v18 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        v41 /*: any*/ ,
                                                                        v42 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareProjectState",
                                                    "kind": "LinkedField",
                                                    "name": "oldState",
                                                    "plural": false,
                                                    "selections": v47 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "oldDueDate",
                                                    "plural": false,
                                                    "selections": v46 /*: any*/ 
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "newTargetDateConfidence"
                                                },
                                                {
                                                    "concreteType": "TownsquareUpdateNoteConnection",
                                                    "kind": "LinkedField",
                                                    "name": "updateNotes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareUpdateNoteEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUpdateNote",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "archived"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "TownsquareHighlightConnection",
                                                    "kind": "LinkedField",
                                                    "name": "highlights",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareHighlightEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v35 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isTownsquareHighlight"
                                                                        },
                                                                        v49 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v51 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                },
                                                v45 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareHighlightEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v52 /*: any*/ ,
                                                    "type": "TownsquareLearning"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v52 /*: any*/ ,
                                                    "type": "TownsquareRisk"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v52 /*: any*/ ,
                                                    "type": "TownsquareDecision"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v23 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "TownsquareCustomFieldConnection",
                            "kind": "LinkedField",
                            "name": "customFields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "TownsquareCustomFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v53 /*: any*/ ,
                                                                    "type": "TownsquareTextCustomFieldDefinition"
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "alias": "textValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v53 /*: any*/ ,
                                                                    "type": "TownsquareNumberCustomFieldDefinition"
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                                            "kind": "LinkedField",
                                                            "name": "value",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "alias": "numberValue",
                                                                    "kind": "ScalarField",
                                                                    "name": "value"
                                                                }
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareNumberCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v53 /*: any*/ ,
                                                                    "type": "TownsquareUserCustomFieldDefinition"
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v54 /*: any*/ ,
                                                            "concreteType": "TownsquareUserConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareUserEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v18 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v55 /*: any*/ 
                                                                    ]
                                                                },
                                                                v56 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v54 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldUser_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v23 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareUserCustomField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v37 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "definition",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canSetMultipleValues"
                                                                        },
                                                                        {
                                                                            "args": v54 /*: any*/ ,
                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "allowedValues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                v32 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "allowedValues(first:100)"
                                                                        }
                                                                    ],
                                                                    "type": "TownsquareTextSelectCustomFieldDefinition"
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v54 /*: any*/ ,
                                                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "values",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                {
                                                                                    "alias": "selectValue",
                                                                                    "kind": "ScalarField",
                                                                                    "name": "value"
                                                                                },
                                                                                v18 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v55 /*: any*/ 
                                                                    ]
                                                                },
                                                                v56 /*: any*/ ,
                                                                v23 /*: any*/ 
                                                            ],
                                                            "storageKey": "values(first:100)"
                                                        },
                                                        {
                                                            "args": v54 /*: any*/ ,
                                                            "handle": "connection",
                                                            "key": "CustomFieldTextSelect_values",
                                                            "kind": "LinkedHandle",
                                                            "name": "values"
                                                        },
                                                        v23 /*: any*/ 
                                                    ],
                                                    "type": "TownsquareTextSelectCustomField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "TownsquareProjectCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v57 /*: any*/ ,
                                        v58 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                        },
                                        v13 /*: any*/ 
                                    ],
                                    "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedJiraWorkItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v29 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v59 /*: any*/ ,
                                                                v35 /*: any*/ ,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "permission",
                                                                            "value": "EDIT_ISSUES"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasProjectPermission",
                                                                    "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                                                                },
                                                                {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "statusId"
                                                                        },
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "statusCategoryId"
                                                                                },
                                                                                v6 /*: any*/ ,
                                                                                v5 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueTypeId"
                                                                        },
                                                                        v6 /*: any*/ ,
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssue"
                                                        },
                                                        v39 /*: any*/ 
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isProjectNativeIntegrationEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "workTrackingLinks",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "WORK_TRACKING"
                                        }
                                    ],
                                    "concreteType": "TownsquareLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": v36 /*: any*/ ,
                                    "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
                                },
                                {
                                    "concreteType": "TownsquareFusionDetails",
                                    "kind": "LinkedField",
                                    "name": "fusion",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "synced"
                                        },
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v59 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "TownsquareProjectCapabilities",
                                    "kind": "LinkedField",
                                    "name": "capabilities",
                                    "plural": false,
                                    "selections": [
                                        v58 /*: any*/ ,
                                        v57 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v23 /*: any*/ 
                    ]
                },
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "TownsquareProjectAppCapabilities",
                    "kind": "LinkedField",
                    "name": "projects_capabilities",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canCreateProject"
                        }
                    ]
                },
                v16 /*: any*/ ,
                {
                    "concreteType": "MercuryQueryApi",
                    "kind": "LinkedField",
                    "name": "mercury",
                    "plural": false,
                    "selections": [
                        {
                            "args": v17 /*: any*/ ,
                            "concreteType": "MercuryWorkspaceContext",
                            "kind": "LinkedField",
                            "name": "workspaceContext",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "activationId"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fe6e28ba0ed4a244d010dbc95d5fd7f23e44c1db00ca6445ad94c2d958ab2de5",
            "metadata": {},
            "name": "ProjectPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$13f6ba1ca2449bb6$var$node.hash = "acaac2c30e01881861ceeb37c2cb458f";
var $13f6ba1ca2449bb6$export$2e2bcd8739ae039 = $13f6ba1ca2449bb6$var$node;
module.exports["default"] = $13f6ba1ca2449bb6$export$2e2bcd8739ae039;

});

parcelRegister("fJCUp", function(module, exports) {

let $b7493d7a8f7f39ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b7493d7a8f7f39ee$var$load("kT6dz"),
    $b7493d7a8f7f39ee$var$load("8yk9S"),
    $b7493d7a8f7f39ee$var$load("6C7Vr"),
    $b7493d7a8f7f39ee$var$load("1GcJI"),
    $b7493d7a8f7f39ee$var$load("bXcw7"),
    $b7493d7a8f7f39ee$var$load("j2Da2"),
    $b7493d7a8f7f39ee$var$load("fV5Jo"),
    $b7493d7a8f7f39ee$var$load("8hP2l"),
    $b7493d7a8f7f39ee$var$load("1XtfK"),
    $b7493d7a8f7f39ee$var$load("80Yra"),
    $b7493d7a8f7f39ee$var$load("2OemJ"),
    $b7493d7a8f7f39ee$var$load("hUbK8"),
    $b7493d7a8f7f39ee$var$load("alg5Q"),
    $b7493d7a8f7f39ee$var$load("g4bFE"),
    $b7493d7a8f7f39ee$var$load("exl8k"),
    $b7493d7a8f7f39ee$var$load("1Gr4q"),
    $b7493d7a8f7f39ee$var$load("2mGc6"),
    $b7493d7a8f7f39ee$var$load("d19Pa"),
    $b7493d7a8f7f39ee$var$load("fB5NV"),
    $b7493d7a8f7f39ee$var$load("ir5Be"),
    $b7493d7a8f7f39ee$var$load("kccW9"),
    $b7493d7a8f7f39ee$var$load("iPvQ1"),
    $b7493d7a8f7f39ee$var$load("iOfkQ"),
    $b7493d7a8f7f39ee$var$load("84Qrx"),
    $b7493d7a8f7f39ee$var$load("7SteV"),
    $b7493d7a8f7f39ee$var$load("k72sK"),
    $b7493d7a8f7f39ee$var$load("kD76L"),
    $b7493d7a8f7f39ee$var$load("8H6bN"),
    $b7493d7a8f7f39ee$var$load("eUsnQ"),
    $b7493d7a8f7f39ee$var$load("3vH95"),
    $b7493d7a8f7f39ee$var$load("fnO1K"),
    $b7493d7a8f7f39ee$var$load("dZYhM"),
    $b7493d7a8f7f39ee$var$load("7LDtT"),
    $b7493d7a8f7f39ee$var$load("1YU2Y"),
    $b7493d7a8f7f39ee$var$load("4GjU8"),
    $b7493d7a8f7f39ee$var$load("exK5D"),
    $b7493d7a8f7f39ee$var$load("1ThhV"),
    $b7493d7a8f7f39ee$var$load("4KIrO"),
    $b7493d7a8f7f39ee$var$load("kkkxt"),
    $b7493d7a8f7f39ee$var$load("1FRba"),
    $b7493d7a8f7f39ee$var$load("eyDge"),
    $b7493d7a8f7f39ee$var$load("4x9Jx"),
    $b7493d7a8f7f39ee$var$load("iWnyc"),
    $b7493d7a8f7f39ee$var$load("ipIDQ"),
    $b7493d7a8f7f39ee$var$load("ea3NB"),
    $b7493d7a8f7f39ee$var$load("6wr18"),
    $b7493d7a8f7f39ee$var$load("59hV4"),
    $b7493d7a8f7f39ee$var$load("fibpY"),
    $b7493d7a8f7f39ee$var$load("4O6U4"),
    $b7493d7a8f7f39ee$var$load("5He1y"),
    $b7493d7a8f7f39ee$var$load("6bjEk"),
    $b7493d7a8f7f39ee$var$load("ffEVr"),
    $b7493d7a8f7f39ee$var$load("i7f39"),
    $b7493d7a8f7f39ee$var$load("hwJJ4"),
    $b7493d7a8f7f39ee$var$load("6zCMk"),
    $b7493d7a8f7f39ee$var$load("hhss7"),
    $b7493d7a8f7f39ee$var$load("Wowvf"),
    $b7493d7a8f7f39ee$var$load("lkxmG"),
    $b7493d7a8f7f39ee$var$load("7EorR"),
    $b7493d7a8f7f39ee$var$load("Lm7SH"),
    $b7493d7a8f7f39ee$var$load("fYAGb")
]).then(()=>parcelRequire('h4ylq'));

});

parcelRegister("fOZAE", function(module, exports) {
/**
 * @generated SignedSource<<9fb35c2d4439f6873526cfe4dbb0bdbc>>
 * @relayHash 91adf951953bfe64ddb250042a4a0511
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527
const $05c3d23f157af3ac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "args": [
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "cloudIds.0",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
            }
        ],
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "orgId"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "teamPreviewPanelQuery",
            "selections": [
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                v2 /*: any*/ 
            ]
        },
        "params": {
            "id": "1833329048b99734ed78f2acc837e88e917ff4ae53ed33b16de39b8b3f5a0527",
            "metadata": {},
            "name": "teamPreviewPanelQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$05c3d23f157af3ac$var$node.hash = "6b8a5c1e76dd69e5d8daea6919628199";
var $05c3d23f157af3ac$export$2e2bcd8739ae039 = $05c3d23f157af3ac$var$node;
module.exports["default"] = $05c3d23f157af3ac$export$2e2bcd8739ae039;

});

parcelRegister("jlGvh", function(module, exports) {

let $e160f2cf66af21d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e160f2cf66af21d8$var$load("j2Da2"),
    $e160f2cf66af21d8$var$load("fV5Jo"),
    $e160f2cf66af21d8$var$load("8hP2l"),
    $e160f2cf66af21d8$var$load("1XtfK"),
    $e160f2cf66af21d8$var$load("alg5Q"),
    $e160f2cf66af21d8$var$load("8yk9S"),
    $e160f2cf66af21d8$var$load("7asYT"),
    $e160f2cf66af21d8$var$load("7EorR"),
    $e160f2cf66af21d8$var$load("hhss7"),
    $e160f2cf66af21d8$var$load("e4siW"),
    $e160f2cf66af21d8$var$load("9qnaU")
]).then(()=>parcelRequire('h7PZA'));

});

parcelRegister("27fJD", function(module, exports) {

var $yx6Pm = parcelRequire("yx6Pm");

var $6B1vK = parcelRequire("6B1vK");

var $iJxD8 = parcelRequire("iJxD8");

var $fjKr7 = parcelRequire("fjKr7");

var $1RQo0 = parcelRequire("1RQo0");

var $aLUFu = parcelRequire("aLUFu");


var $9wGTI = parcelRequire("9wGTI");


var $eToX6 = parcelRequire("eToX6");

const $8d12b9c9b8a8c583$export$cec6f7cb9c99f251 = [
    'jira-issue',
    'confluence-page',
    'identity-team',
    'townsquare-goal',
    'townsquare-project',
    'cmdb-object'
];
const $8d12b9c9b8a8c583$export$9e4592d635e5db5b = ({ ari: ari })=>{
    const href = window?.location?.href;
    if (href) {
        const searchParams = new URL(href).searchParams;
        if (searchParams.get('parentProduct')?.toLowerCase() === 'jsm') return false;
        if ((0, $eToX6.isInIframe)() && !(0, $eToX6.hasPreviewPanelIndicators)(searchParams)) return false;
    }
    if ((0, $6B1vK.ConfluencePageAri).check(ari)) return true;
    if ((0, $fjKr7.JiraIssueAri).check(ari)) return true;
    if ((0, $1RQo0.TownsquareGoalAri).check(ari)) return true;
    if ((0, $aLUFu.TownsquareProjectAri).check(ari)) return true;
    if ((0, $iJxD8.IdentityTeamAri).check(ari)) return true;
    if ((0, $yx6Pm.CmdbObjectAri).check(ari) && (0, $9wGTI.fg)('open_preview_panel_for_assets_object_in_confluence')) return true;
    return false;
};
module.exports["isPreviewPanelAvailable"] = $8d12b9c9b8a8c583$export$9e4592d635e5db5b;

});


$parcel$global.rlb("h6m7t")
//# sourceMappingURL=FullPageEditorComponent.da6e8dd9.js.map
